<template>
  <div class="card">
    <div style="padding-left: 15px; padding-right: 15px">
      <div class="d-flex company-profile-top">
        <div class="company-profile-top-parent">
          <!-- <div
          class="company-profile-badge badge badge-success"
          style="margin-top:2px"
          >{{data.status}}</div>-->
          <div :style="statusBadge.style" class="company-profile-badge">
            <span
              class="companyProfileStatusBadgeValue"
              v-if="!statusChangePermission()"
              >{{ statusBadge.value }}</span
            >

            <el-select
              class="status-dd"
              size="small"
              placeholder="Select Status"
              v-model="statusBadge.value"
              @change="handleStatusChange()"
              v-if="statusChangePermission()"
            >
              <el-option
                v-for="option in vals.STATUS_DEFINES"
                class
                :value="option"
                :label="option"
                :key="option"
              ></el-option>
            </el-select>
          </div>

          <span style="flex: 1 1 auto"></span>
          <div class="ellipsesDropdownLayout">
            <b-dropdown
              size="sm"
              variant
              right
              class="company-card-dropdown"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template
                v-slot:button-content
                style="border: 0; background: none"
              >
                <i
                  class="fa fa-ellipsis-h"
                  aria-hidden="true"
                  style="color: #00000080"
                ></i>
              </template>
              <b-dropdown-item @click="downloadAsPdf"
                >Download as PDF</b-dropdown-item
              >
              <!-- <b-dropdown-item @click="modalShow=true;refreshForm=true">Share</b-dropdown-item> -->
              <b-dropdown-item @click="handleEditCompany" v-if="showEditCompany"
                >Edit Company</b-dropdown-item
              >
              <b-dropdown-item
                @click="showDeleteModal = true"
                v-if="showDeleteCompany"
                >Delete</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div class="flex-grow-1" style="text-align: center">
          <img
            :src="image"
            class="rounded-circle"
            style="width: 120px; height: 120px"
          />
        </div>
      </div>
    </div>
    <div
      class
      style="text-align: center; padding-left: 20px; padding-right: 15px"
    >
      <div class="company-profile-name">{{ data.name }}</div>
      <div class="company-profile-sector">
        {{ data.sector }}-{{ filterCategoryData }}
      </div>
      <div class="d-flex" style="justify-content: center">
        <div v-html="starRatings">{{}}</div>
        <div class="company-profile-rating-number">{{ rating }}</div>
      </div>
    </div>
    <div>
      <div
        :style="
          showEditIcon
            ? 'margin-bottom:20px;background-color:#F1F1F2'
            : 'margin-bottom:20px;'
        "
        @mouseover="
          showEditIcon = !isUpdatedByCompany;
          showHistoryIcon = true;
        "
        @mouseleave="
          showEditIcon = false;
          showHistoryIcon = false;
        "
      >
        <div style="padding-left: 20px; padding-right: 15px; padding-top: 15px">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="tractionTitle">Current KPI's</div>
            </div>
            <div class="d-flex">
              <div
                v-if="showHistoryIcon"
                style="cursor: pointer"
                title="See History"
                class="d-flex"
                @click="handleHistory"
              >
                <i class="fas fa-history"></i>
              </div>
              <div
                class="d-flex"
                v-if="showEditIcon"
                style="cursor: pointer; margin-left: 20px"
                @click="handleEditCurrentKPI"
                title="Edit Current KPI"
              >
                <img src="static/img/tractionEdit.svg" class />
              </div>
            </div>
          </div>
          <div style="padding-bottom: 15px; padding-top: 15px">
            <table class="tractionTable">
              <tr v-for="field in tractionTableFields" :key="field.label">
                <th>{{ field.label }}</th>
                <td>
                  <span
                    style="
                      line-height: 1.5;
                      display: inline-block;
                      max-width: 100%;
                    "
                    v-html="field.value"
                    >{{}}</span
                  >
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      style="padding-bottom: 20px; padding-left: 20px; padding-right: 15px"
      class
    >
      <table class="portfolio-company-left-table-data">
        <tr v-for="field in companyTableFields" :key="field.label">
          <th>{{ field.label }}</th>
          <td>
            <span
              style="line-height: 1.5; display: inline-block; max-width: 100%"
              v-html="field.value"
              >{{}}</span
            >
          </td>
          <!-- <td
            v-if="field.label=='Headquarters:' && field.value!='-'"
            v-b-tooltip.hover="{ variant: 'primary' }"
            :title="field.value"
          >
            <span style="line-height: 1.5;display: inline-block;max-width: 100%;">{{field.value}}</span>
          </td>
          <td v-else>
            <span
              style="line-height: 1.5;display: inline-block;max-width: 100%;"
              v-html="field.value"
            >{{}}</span>
          </td>-->
        </tr>
      </table>
    </div>
    <div style="padding-left: 20px; padding-right: 15px">
      <div class="company-profile-company-description-title">
        Company Description
      </div>
      <div id="companyDescription" class="company-profile-company-description">
        <div v-if="data.description && data.description.length <= 200">
          {{ data.description }}
        </div>
        <div
          v-if="
            data.description &&
            data.description.length > 200 &&
            companyDesc.length <= 200
          "
        >
          {{ companyDesc }} ...
          <span
            @click="descriptionClick('more')"
            class="company-profile-company-description-show-more-less"
            >Show more</span
          >
        </div>
        <div
          v-if="
            data.description &&
            data.description.length > 200 &&
            companyDesc.length > 200
          "
        >
          {{ companyDesc }}
          <span
            @click="descriptionClick('less')"
            class="company-profile-company-description-show-more-less"
            >Show less</span
          >
        </div>
      </div>
    </div>
    <div style="padding-top: 20px; padding-left: 20px; padding-right: 15px">
      <div class="company-profile-people-title" v-if="founders.length > 0">
        Founders
      </div>
      <div
        class="company-profile-people-title"
        style="color: #676767 !important"
        v-if="founders.length == 0"
      >
        Founders
      </div>
      <div v-if="founderArray && founderArray.length > 0">
        <div
          class="d-flex peoplePopOverMouseOver"
          style="padding-bottom: 10px"
          v-for="(item, index) in founderArray"
          :key="index"
          :id="'founderPopover' + item._id + index"
          @mouseover="setPopoverData(item, index)"
        >
          <b-popover
            :target="'founderPopover' + item._id + index"
            triggers="hover"
            placement="topright"
            custom-class
          >
            <div>
              <div class="row">
                <div class="col-4 peoplePopOverImage">
                  <img
                    width="77"
                    height="77"
                    class="rounded-circle"
                    v-bind:src="
                      item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
                    "
                  />
                </div>
                <div class="col-8">
                  <div class="peoplePopoverName">{{ item.name }}</div>
                  <div v-if="item.job_title" style>{{ item.job_title }}</div>
                  <div v-if="item.city">{{ item.city }}</div>
                  <div class="d-flex">
                    <div v-if="item.facebook_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.facebook_url"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.url_linkedin">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.url_linkedin"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.twitter_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.twitter_url"
                        target="_blank"
                      >
                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <div v-if="num_portfolio_organization">
                  <div class="popoverTitleCls">Portfolio</div>
                  <div class="popoverValueCls">
                    {{ num_portfolio_organization }}
                  </div>
                </div>
                <div v-if="exits">
                  <div class="popoverTitleCls">Exits</div>
                  <div class="popoverValueCls">{{ exits }}</div>
                </div>
                <div v-if="investedCompanies.length">
                  <div class="popoverTitleCls">Co-invested</div>
                  <div class="popoverValueCls">
                    {{ investedCompanies.length }}
                  </div>
                </div>
              </div>
            </div>
          </b-popover>
          <div style="padding-right: 8px">
            <img
              v-bind:src="
                item.image_id && item.image_id.length > 0
                  ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                  : `${
                      item.image && item.image.length > 0
                        ? item.image
                        : 'static/img/faces/face-0.jpg'
                    }`
              "
              width="20"
              height="20"
              class="rounded-circle"
            />
          </div>
          <div class="company-profile-people-name">{{ item.name }}</div>
        </div>
        <div
          v-if="founders.length > 3 && founderArray.length == 3"
          class="company-profile-people-more-less"
          @click="founderclick('founder', 'more')"
        >
          {{ founders.length - 3 }} more
        </div>
        <div
          v-if="founders.length > 3 && founderArray.length > 3"
          class="company-profile-people-more-less"
          @click="founderclick('founder', 'less')"
        >
          Show less
        </div>
      </div>
    </div>
    <div style="padding-top: 20px; padding-left: 20px; padding-right: 15px">
      <div class="company-profile-people-title" v-if="investors.length > 0">
        Investors
      </div>
      <div
        class="company-profile-people-title"
        style="color: #676767 !important"
        v-if="investors.length == 0"
      >
        Investors
      </div>
      <div v-if="investorArray && investorArray.length > 0">
        <div
          class="d-flex peoplePopOverMouseOver"
          style="padding-bottom: 10px"
          v-for="(item, index) in investorArray"
          :key="index"
          :id="'investorPopover' + item._id + index"
          @mouseover="setPopoverData(item, index)"
        >
          <b-popover
            :target="'investorPopover' + item._id + index"
            triggers="hover"
            placement="topright"
            custom-class
          >
            <div>
              <div class="row">
                <div class="col-4 peoplePopOverImage">
                  <img
                    width="77"
                    height="77"
                    class="rounded-circle"
                    v-bind:src="
                      item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
                    "
                  />
                </div>
                <div class="col-8">
                  <div class="peoplePopoverName">{{ item.name }}</div>
                  <div v-if="item.job_title" style>{{ item.job_title }}</div>
                  <div v-if="item.city">{{ item.city }}</div>
                  <div
                    v-if="item.funding_round && item.funding_round.length > 1"
                  >
                    Funding Round:{{ item.funding_round }}
                  </div>
                  <div
                    v-if="item.lead_investor && item.lead_investor.length > 1"
                  >
                    Lead Investor:{{ item.lead_investor }}
                  </div>
                  <div class="d-flex">
                    <div v-if="item.facebook_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.facebook_url"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.url_linkedin">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.url_linkedin"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.twitter_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.twitter_url"
                        target="_blank"
                      >
                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <div v-if="num_portfolio_organization">
                  <div class="popoverTitleCls">Portfolio</div>
                  <div class="popoverValueCls">
                    {{ num_portfolio_organization }}
                  </div>
                </div>
                <div v-if="exits">
                  <div class="popoverTitleCls">Exits</div>
                  <div class="popoverValueCls">{{ exits }}</div>
                </div>
                <div v-if="investedCompanies.length">
                  <div class="popoverTitleCls">Co-invested</div>
                  <div class="popoverValueCls">
                    {{ investedCompanies.length }}
                  </div>
                </div>
              </div>
            </div>
          </b-popover>
          <div style="padding-right: 8px">
            <img
              v-bind:src="
                item.image_id && item.image_id.length > 0
                  ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                  : `${
                      item.image && item.image.length > 0
                        ? item.image
                        : 'static/img/faces/face-0.jpg'
                    }`
              "
              width="20"
              height="20"
              class="rounded-circle"
            />
          </div>
          <div class="company-profile-people-name">{{ item.name }}</div>
        </div>
        <div
          v-if="investors.length > 5 && investorArray.length == 5"
          class="company-profile-people-more-less"
          @click="founderclick('investor', 'more')"
        >
          {{ investors.length - 5 }} more
        </div>
        <div
          v-if="investors.length > 5 && investorArray.length > 5"
          class="company-profile-people-more-less"
          @click="founderclick('investor', 'less')"
        >
          Show less
        </div>
      </div>
    </div>
    <div style="padding-top: 20px; padding-left: 20px; padding-right: 15px">
      <div class="company-profile-people-title" v-if="advisors.length > 0">
        Advisors
      </div>
      <div
        class="company-profile-people-title"
        style="color: #676767 !important"
        v-if="advisors.length == 0"
      >
        Advisors
      </div>
      <div v-if="advisorArray && advisorArray.length > 0">
        <div
          class="d-flex peoplePopOverMouseOver"
          v-for="(item, index) in advisorArray"
          :key="index"
          :id="'advisorPopover' + item._id + index"
          @mouseover="setPopoverData(item, index)"
        >
          <b-popover
            :target="'advisorPopover' + item._id + index"
            triggers="hover"
            placement="topright"
            custom-class
          >
            <div>
              <div class="row">
                <div class="col-4 peoplePopOverImage">
                  <img
                    width="77"
                    height="77"
                    class="rounded-circle"
                    v-bind:src="
                      item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
                    "
                  />
                </div>
                <div class="col-8">
                  <div class="peoplePopoverName">{{ item.name }}</div>
                  <div v-if="item.job_title" style>{{ item.job_title }}</div>
                  <div v-if="item.city">{{ item.city }}</div>
                  <div class="d-flex">
                    <div v-if="item.facebook_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.facebook_url"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.url_linkedin">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.url_linkedin"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.twitter_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.twitter_url"
                        target="_blank"
                      >
                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <div v-if="num_portfolio_organization">
                  <div class="popoverTitleCls">Portfolio</div>
                  <div class="popoverValueCls">
                    {{ num_portfolio_organization }}
                  </div>
                </div>
                <div v-if="exits">
                  <div class="popoverTitleCls">Exits</div>
                  <div class="popoverValueCls">{{ exits }}</div>
                </div>
                <div v-if="investedCompanies.length">
                  <div class="popoverTitleCls">Co-invested</div>
                  <div class="popoverValueCls">
                    {{ investedCompanies.length }}
                  </div>
                </div>
              </div>
            </div>
          </b-popover>
          <div style="padding-right: 8px">
            <img
              v-bind:src="
                item.image_id && item.image_id.length > 0
                  ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                  : `${
                      item.image && item.image.length > 0
                        ? item.image
                        : 'static/img/faces/face-0.jpg'
                    }`
              "
              width="20"
              height="20"
              class="rounded-circle"
            />
          </div>
          <div class="company-profile-people-name">{{ item.name }}</div>
        </div>
        <div
          v-if="advisors.length > 4 && advisorArray.length == 4"
          class="company-profile-people-more-less"
          @click="founderclick('advisor', 'more')"
        >
          {{ advisors.length - 4 }} more
        </div>
        <div
          v-if="advisors.length > 4 && advisorArray.length > 4"
          class="company-profile-people-more-less"
          @click="founderclick('advisor', 'less')"
        >
          Show less
        </div>
      </div>
    </div>
    <div
      style="
        padding-top: 20px;
        padding-bottom: 10px;
        padding-left: 20px;
        padding-right: 15px;
      "
    >
      <div class="company-profile-people-title" v-if="employees.length > 0">
        Employees
      </div>
      <div
        class="company-profile-people-title"
        style="color: #676767 !important"
        v-if="employees.length == 0"
      >
        Employees
      </div>
      <div v-if="employeeArray && employeeArray.length > 0">
        <div
          class="d-flex peoplePopOverMouseOver"
          v-for="(item, index) in employeeArray"
          :key="index"
          :id="'employeePopover' + item._id + index"
          @mouseover="setPopoverData(item, index)"
        >
          <b-popover
            :target="'employeePopover' + item._id + index"
            triggers="hover"
            placement="topright"
            custom-class
          >
            <div>
              <div class="row">
                <div class="col-4 peoplePopOverImage">
                  <img
                    width="77"
                    height="77"
                    class="rounded-circle"
                    v-bind:src="
                      item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
                    "
                  />
                </div>
                <div class="col-8">
                  <div class="peoplePopoverName">{{ item.name }}</div>
                  <div v-if="item.job_title" style>{{ item.job_title }}</div>
                  <div v-if="item.city">{{ item.city }}</div>
                  <div class="d-flex">
                    <div v-if="item.facebook_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.facebook_url"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.url_linkedin">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.url_linkedin"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.twitter_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.twitter_url"
                        target="_blank"
                      >
                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <div v-if="num_portfolio_organization">
                  <div class="popoverTitleCls">Portfolio</div>
                  <div class="popoverValueCls">
                    {{ num_portfolio_organization }}
                  </div>
                </div>
                <div v-if="exits">
                  <div class="popoverTitleCls">Exits</div>
                  <div class="popoverValueCls">{{ exits }}</div>
                </div>
                <div v-if="investedCompanies.length">
                  <div class="popoverTitleCls">Co-invested</div>
                  <div class="popoverValueCls">
                    {{ investedCompanies.length }}
                  </div>
                </div>
              </div>
            </div>
          </b-popover>
          <div style="padding-right: 8px">
            <img
              v-bind:src="
                item.image_id && item.image_id.length > 0
                  ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                  : `${
                      item.image && item.image.length > 0
                        ? item.image
                        : 'static/img/faces/face-0.jpg'
                    }`
              "
              width="20"
              height="20"
              class="rounded-circle"
            />
          </div>
          <div class="company-profile-people-name">{{ item.name }}</div>
        </div>
        <div
          v-if="employees.length > 4 && employeeArray.length == 4"
          class="company-profile-people-more-less"
          @click="founderclick('employee', 'more')"
        >
          {{ employees.length - 4 }} more
        </div>
        <div
          v-if="employees.length > 4 && employeeArray.length > 4"
          class="company-profile-people-more-less"
          @click="founderclick('employee', 'less')"
        >
          Show less
        </div>
      </div>
    </div>
    <editCompany
      ref="editCompanyRef"
      @company-save="companySave"
      v-model="editCompanyModalProps"
      v-if="showEditModalPopup"
    ></editCompany>
    <el-dialog
      left
      title="Share Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="500px"
      style="margin: 0 auto"
      :visible.sync="modalShow"
      @close="
        sharingNote = '';
        tags = [];
        refreshForm = false;
      "
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div>
        <div>Email</div>
        <b-form-group :state="state" label-for="tags-validation">
          <b-form-tags
            input-id="tags-validation"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            v-model="tags"
            v-if="refreshForm"
            :state="state"
            placeholder="Enter Emails separated by comma"
            tag-variant="primary"
            invalid-tag-text="Invalid email(s)"
            duplicate-tag-text="Duplicate email(s)"
            tag-pills
            add-on-change
            :tag-validator="tagValidator"
            @tag-state="onTagState"
            separator=","
          ></b-form-tags>
          <!-- The following slots are for b-form-group
          <template v-slot:invalid-feedback>You must provide at least 1 email and no more than 6</template>-->
          <!-- <template v-slot:description>
            <div id="tags-validation-help">Must be a valid Email</div>
          </template>-->
        </b-form-group>
        <div>Notes</div>
        <textarea
          placeholder="Note"
          rows="5"
          cols="50"
          class="form-control"
          spellcheck="false"
          v-model="sharingNote"
        ></textarea>
        <div class="edit-company-action-button-row py-3" style="margin: 0px">
          <button
            type="button"
            @click="modalShow = !modalShow"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <button
            type="button"
            @click.prevent="sendEmail"
            :disabled="emailCheck || submit"
            class="btn btn-info btn-fill btn-wd"
            style="height: 35px"
          >
            Send
            <b-spinner
              v-if="submit"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="Really Delete?"
      :context="modalContext"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      width="400px"
      :visible.sync="showDeleteModal"
    >
      <confirm-card
        :context="modalContext"
        @confirm-card-close="closeModal"
      ></confirm-card>
    </el-dialog>

    <el-dialog
      center
      title="Confirm?"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      width="365px"
      :visible.sync="showConfirmModal"
    >
      <div>
        {{ statusConfirmMessage }}

        <div style="margin-top: 20px">
          <button
            type="button"
            @click="cancelConfirmStatusChange()"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            No
          </button>
          <button
            type="button"
            @click="confirmStatusChange()"
            class="btn btn-info btn-fill btn-wd"
            style="height: 35px; margin-left: 30px"
          >
            Yes
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      top
      :title="isEditKpi ? `Edit KPI` : `Edit Current KPI`"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      :visible.sync="isShow"
      style="margin: 0 auto"
      class="editCompanyPopup col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="row">
        <div class="col-12 investor-table-wrapper">
          <div class="row">
            <div class="col-6">
              <div>Cash on Hand</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="Cash on Hand"
                v-model="editTractionData.cash"
                @keyup="setRunwayAndCashOutDate"
              />
            </div>
            <div class="col-6">
              <div>Monthly Burn</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="Monthly Burn"
                v-model="editTractionData.monthlyBurn"
                @keyup="setRunwayAndCashOutDate"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>Runway (Months)</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="Runway (Months)"
                v-model="editTractionDataRunway"
                disabled
              />
            </div>
            <div class="col-6">
              <div>Cash Out Date</div>
              <input
                type="date"
                class="form-control"
                placeholder="Cash Out Date"
                v-model="editTractionDataCashOutDate"
                disabled
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>MRR</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="MRR"
                v-model="editTractionData.mrr"
              />
            </div>
            <div class="col-6">
              <div>ARR</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="ARR"
                v-model="editTractionData.arr"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>Other Types of Revenue</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="Other Types of Revenue"
                v-model="editTractionData.revenue"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>No. of Paying Customers</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="No. of Paying Customers"
                v-model="editTractionData.payingCustomers"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>Number of Customers</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="Number of Customers"
                v-model="editTractionData.customers"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>Churn</div>
              <input
                type="Number"
                class="form-control"
                min="0"
                placeholder="Churn"
                v-model="editTractionData.churn"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>Type of Contract</div>
              <el-select
                class="todo-dropdown-el-select"
                size="large"
                placeholder="Select Type of Contract"
                v-model="editTractionDataContractType"
              >
                <el-option
                  v-for="option in contractArray"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <div class="col-6">
              <div>Date Received</div>
              <input
                class="todo-form-date todo-form form-control"
                type="date"
                v-model="editTractionDataDate"
                placeholder="Date Received"
              />
            </div>
          </div>
          <div slot="footer" class="dialog-footer" style>
            <div
              class="col-xl edit-company-action-button-row"
              style="padding: 0px; margin-top: 30px"
            >
              <button
                type="button"
                class="todo-form-cancel-button btn-outline-secondary"
                @click.prevent="handleCancel"
              >
                Cancel
              </button>
              <button
                type="button"
                class="todo-form-submit-button btn btn-primary"
                @click.prevent="writeToServer"
                :disabled="showSpinner"
              >
                Save
                <b-spinner
                  v-if="showSpinner"
                  style="float: right"
                  small
                  label="Loading..."
                ></b-spinner>
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      left
      title="KPI History"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="90%"
      :visible.sync="showHistoryTableModal"
      class="tractionHistoryModal"
    >
      <div class="row ml-0 mr-0 w-100">
        <div
          class="todos-table-parent companyProfileTabulatorLayout companyProfileTabulatorInvestFundTable tractionHistoryTable"
          ref="historyTabulator"
          style="min-height: 240px"
        ></div>
      </div>
    </el-dialog>

    <el-dialog
      left
      title="IPO"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="470px"
      :visible.sync="showIPODialog"
      @close="handleIPOCancel"
      class="ipo-modal"
    >
      <div class="row ml-0 mr-0 w-100" style="min-width: 430px">
        <form @submit.prevent="ipoSave">
          <div class="col-12">
            <div>
              Have you sold your shares?
              <!-- <span class="required">*</span> -->
            </div>

            <div class="radio-wrapper">
              <l-radio
                v-bind:groupname="'sold'"
                v-model="ipoSoldShare"
                value="yes"
                label="Yes"
                >Yes</l-radio
              >
              <l-radio
                v-bind:groupname="'sold'"
                v-model="ipoSoldShare"
                value="no"
                label="No"
                >No</l-radio
              >
            </div>

            <span v-if="ipoSoldShare === 'Yes'">
              <div class="row">
                <div class="col-6">
                  <div>Total Proceeds</div>
                  <input
                    type="number"
                    class="form-control team-form"
                    style="width: 100%"
                    @keyup="calculateIPOProceedsDistributionRecycled('total')"
                    v-model="ipoTotalProceeds"
                    placeholder=""
                    step="0.000001"
                    min="0"
                  />
                </div>
                <div class="col-6">
                  <div># of Shares</div>
                  <input
                    type="number"
                    class="form-control team-form"
                    style="width: 100%"
                    step="1"
                    v-model="ipoNumberOfShares"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div>Date Sold</div>
                  <input
                    type="date"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="ipoDateSold"
                    placeholder=""
                    min="0"
                  />
                </div>
                <div class="col-6">
                  <div>Price Per Share (PPS)</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="ipoPricePerShare"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div>Distribution</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    @keyup="
                      calculateIPOProceedsDistributionRecycled('distribution')
                    "
                    v-model="ipoDistribution"
                    placeholder=""
                    min="0"
                  />
                </div>
                <div class="col-6">
                  <div>Recycled $</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    @keyup="
                      calculateIPOProceedsDistributionRecycled('recycled')
                    "
                    v-model="ipoRecycled"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>
            </span>

            <span v-if="ipoSoldShare === 'No'">
              <div class="row">
                <div class="col-6">
                  <div>Price Per Share (PPS)</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="ipoPricePerShare"
                    placeholder=""
                    min="0"
                  />
                </div>
                <div class="col-6">
                  <div># of Shares You Hold</div>
                  <input
                    type="number"
                    step="1"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="ipoNumberOfSharesYouHold"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div>Lock Up Start Date</div>
                  <input
                    type="date"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="ipoLockUpStartDate"
                    placeholder=""
                    min="0"
                  />
                </div>
                <div class="col-6">
                  <div>Period (in days)</div>
                  <input
                    type="number"
                    step="1"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="ipoPeriod"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>
              <div class="row lockup-text">
                <div class="col-6">
                  <div>Lock Up End Date</div>
                </div>
                <div class="col-6">
                  <div>{{ ipoLockupEndDate }}</div>
                </div>
              </div>
            </span>

            <!-- 
            Agent Info
          -->
            <div class="row">
              <div class="col-12">
                <b>Agent Info</b>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <div>Name</div>
                <input
                  type="text"
                  class="form-control team-form"
                  style="width: 100%"
                  v-model="ipoAgentName"
                  placeholder=""
                  min="0"
                />
              </div>
              <div class="col-6">
                <div>Company</div>
                <input
                  type="text"
                  class="form-control team-form"
                  style="width: 100%"
                  v-model="ipoAgentCompany"
                  placeholder=""
                  min="0"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div>Phone</div>
                <input
                  type="text"
                  class="form-control team-form"
                  style="width: 100%"
                  v-model="ipoAgentPhone"
                  placeholder=""
                  min="0"
                />
              </div>
              <div class="col-6">
                <div>Email</div>
                <input
                  type="text"
                  class="form-control team-form"
                  style="width: 100%"
                  v-model="ipoAgentEmail"
                  placeholder=""
                  min="0"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div>Note</div>
                <textarea
                  placeholder="Note"
                  rows="5"
                  cols="50"
                  class="form-control"
                  spellcheck="false"
                  v-model="ipoAgentNote"
                ></textarea>
              </div>
            </div>
            <div class="row ipo-files">
              <div class="col-12">
                <div style="padding-bottom: 3px">Documents</div>
                <div class="row m-0">
                  <div
                    class="col-4 attach-class"
                    id="popover-target-1"
                    style="padding-top: 6px; min-width: 130px"
                  >
                    <i class="fa fa-paperclip" aria-hidden="true"></i>
                    Attach a file
                    <input
                      type="file"
                      ref="fileBtn"
                      if="fileId"
                      @change="handleFile"
                      class="hidden"
                    />
                  </div>
                  <b-popover
                    target="popover-target-1"
                    triggers="hover"
                    placement="top"
                    custom-class="popover-modal-class"
                  >
                    <div
                      class="m-2"
                      style="cursor: pointer"
                      @click="
                        $refs.fileBtn.click();
                        ipoTypeUrlCheck = false;
                      "
                    >
                      From Computer
                    </div>
                    <div
                      class="m-2"
                      style="cursor: pointer"
                      @click="ipoTypeUrlCheck = !ipoTypeUrlCheck"
                    >
                      Add Link
                    </div>
                  </b-popover>
                  <div
                    class="col-8 drag-drop-class"
                    style="padding-top: 6px"
                    v-if="!ipoTypeUrlCheck"
                    v-cloak
                    @drop.prevent="addFile"
                    @dragover.prevent
                  >
                    Drag and drop file to attach
                  </div>
                  <div class="col-8" style="padding: 0" v-else>
                    <form @submit.prevent="submitUrl">
                      <input
                        type="text"
                        class="form-control team-form url-input-form"
                        placeholder="Add a URL"
                        id="myInput"
                        @blur="submitUrl"
                        v-model="ipoUrlValue"
                        @
                      />
                    </form>
                  </div>
                </div>
                <div class="mt-3">
                  <div v-if="ipoUrl.add">
                    <div
                      v-for="(item, index) in ipoUrl.add"
                      :key="index"
                      class="fileItem my-2"
                    >
                      <a :href="formatUrl(item)" target="_blank">
                        <span class="attachment-name-class">{{ item }}</span>
                      </a>
                      <i
                        class="fas fa-times"
                        @click="deleteURL(index, 'add')"
                        style="
                          float: right;
                          padding-top: 5px;
                          margin-right: 18px;
                          cursor: pointer;
                        "
                      ></i>
                    </div>
                  </div>
                  <div v-if="ipoUrl.update">
                    <div
                      v-for="(item, index) in ipoUrl.update"
                      :key="index"
                      class="fileItem my-2"
                    >
                      <a :href="formatUrl(item.url)" target="_blank">
                        <span class="attachment-name-class">{{
                          item.url
                        }}</span>
                      </a>
                      <i
                        class="fas fa-times"
                        @click="deleteURL(index, 'update')"
                        style="
                          float: right;
                          padding-top: 5px;
                          margin-right: 18px;
                          cursor: pointer;
                        "
                      ></i>
                    </div>
                  </div>
                  <div v-if="ipoFiles.add">
                    <div
                      v-for="(item, index) in ipoFiles.add"
                      :key="index"
                      class="d-flex fileItem my-2"
                    >
                      <i
                        v-if="
                          item.type.includes('.doc') ||
                          item.name.includes('.doc') ||
                          item.name.includes('.txt')
                        "
                        class="fas fa-file-word mr-2 mt-1"
                        style="color: #5190ff"
                      ></i>
                      <i
                        v-else-if="
                          item.type.includes('zip') ||
                          item.name.includes('.zip') ||
                          item.type.includes('rar') ||
                          item.name.includes('.rar')
                        "
                        class="far fa-file-archive mr-2 mt-1"
                      ></i>
                      <i
                        v-else-if="item.type.includes('image')"
                        class="fas fa-image mr-2"
                      ></i>
                      <i
                        v-else-if="
                          item.type.includes('csv') ||
                          item.type.includes('xls') ||
                          item.name.includes('.csv') ||
                          item.name.includes('.xls')
                        "
                        class="fas fa-file-excel mr-2 mt-1"
                        style="color: #f15643"
                      ></i>
                      <i
                        v-else-if="
                          item.type.includes('pdf') ||
                          item.type.includes('.pdf')
                        "
                        class="fas fa-file-pdf mr-2 mt-1"
                      ></i>
                      <span
                        class="attachment-name-class"
                        style="cursor: pointer"
                        >{{ item.name }}</span
                      >
                      <i
                        class="fas fa-times"
                        @click="deleteFile(index, 'add')"
                        style="
                          float: right;
                          padding-top: 5px;
                          margin-right: 18px;
                          cursor: pointer;
                        "
                      ></i>
                    </div>
                  </div>
                  <div v-if="ipoFiles.update">
                    <div
                      v-for="(item, index) in ipoFiles.update"
                      :key="index"
                      class="d-flex fileItem my-2"
                    >
                      <i
                        v-if="
                          item.name.includes('.doc') ||
                          item.name.includes('.txt')
                        "
                        style="color: #5190ff"
                        class="fas fa-file-word mr-2 mt-1"
                      ></i>
                      <i
                        v-else-if="
                          item.name.includes('zip') ||
                          item.name.includes('.rar')
                        "
                        class="far fa-file-archive mr-2 mt-1"
                      ></i>
                      <i
                        v-else-if="
                          item.name.includes('.jpg') ||
                          item.name.includes('.png')
                        "
                        class="fas fa-image mr-2 mt-1"
                      ></i>
                      <i
                        v-else-if="
                          item.name.includes('.csv') ||
                          item.name.includes('.xls')
                        "
                        class="fas fa-file-excel mr-2 mt-1"
                        style="color: #f15643"
                      ></i>
                      <i
                        v-else-if="item.name.includes('.pdf')"
                        class="fas fa-file-pdf mr-2"
                      ></i>
                      <span
                        class="attachment-name-class"
                        style="cursor: pointer"
                        @click="handleDownload(item, 's3')"
                        >{{ item.name }}</span
                      >
                      <i
                        class="fas fa-times"
                        @click="deleteFile(index, 'update')"
                        style="
                          float: right;
                          padding-top: 5px;
                          margin-right: 18px;
                          cursor: pointer;
                        "
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="edit-company-action-button-row pt-3" style="margin: 0px">
            <button
              type="button"
              @click="handleIPOCancel()"
              class="todo-form-cancel-button btn-outline-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              :disabled="disableIPOCheck"
              class="todo-form-submit-button btn btn-primary"
              style="height: 35px"
            >
              Save
              <b-spinner
                v-if="isIPOSaving"
                style="float: right"
                small
                label="Loading..."
              ></b-spinner>
            </button>
          </div>
        </form>
      </div>
    </el-dialog>

    <el-dialog
      left
      title="Acquisition"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="470px"
      :visible.sync="showAcquisitionDialog"
      @close="handleAcquisitionCancel"
      class="ipo-modal"
    >
      <div class="col-12 w-100" style="min-width: 430px">
        <form @submit.prevent="acquisitionSave">
          <div>
            <div class="row">
              <div class="col-12">
                <div>
                  Acquiring Company
                  <b-spinner
                    v-if="acquisitionCompaniesLoading"
                    style="float: right"
                    small
                    label="Loading..."
                  ></b-spinner>
                </div>
                <vue-bootstrap-typeahead
                  :data="acquisitionCompaniesList"
                  v-model="acquisitionAquiringCompanyName"
                  class="diligenceAutoCompleteClass"
                  :serializer="checkCompany"
                  :minMatchingChars="1"
                  placeholder="Enter Company Name"
                  @hit="onAfterCompanySelection"
                  ref="acquisitiontypeahead"
                >
                  <template slot="suggestion" slot-scope="{ data }">
                    <div>
                      <div
                        class="dd-icon-wrapper"
                        v-if="
                          data.properties && data.properties.profile_image_url
                        "
                      >
                        <img
                          class="dd-icon"
                          height="30"
                          width="30"
                          :src="getImageUrl(data.properties.profile_image_url)"
                        />
                      </div>

                      {{ data.name || data.properties.name }}
                      <span class="gray" v-if="data && data.properties">{{
                        data.properties.short_description
                      }}</span>
                      <span class="gray" v-if="data.name"
                        >Company from your portfolio</span
                      >
                    </div>
                  </template>
                </vue-bootstrap-typeahead>
              </div>
            </div>

            <div class="row" style="margin: 20px 0 25px 0">
              <div class="col-12">
                <div class="flex-row h-evenly">
                  <button
                    type="button"
                    @click="handleAcquisitionTab('cash')"
                    v-bind:class="{
                      'btn-active': acquisitionType === 'cash',
                      'btn-inactive': acquisitionType !== 'cash',
                    }"
                    class="btn-selection"
                    style="height: 35px"
                  >
                    Cash
                  </button>
                  <button
                    type="button"
                    @click="handleAcquisitionTab('stock')"
                    v-bind:class="{
                      'btn-active': acquisitionType === 'stock',
                      'btn-inactive': acquisitionType !== 'stock',
                    }"
                    class="btn-selection"
                    style="height: 35px"
                  >
                    Stock
                  </button>
                  <button
                    type="button"
                    @click="handleAcquisitionTab('mix')"
                    v-bind:class="{
                      'btn-active': acquisitionType === 'mix',
                      'btn-inactive': acquisitionType !== 'mix',
                    }"
                    class="btn-selection"
                    style="height: 35px"
                  >
                    Mix
                  </button>
                </div>
              </div>
            </div>

            <span
              v-if="acquisitionType === 'mix' || acquisitionType === 'cash'"
            >
              <div class="row" v-if="acquisitionType === 'mix'">
                <div class="col-12">
                  <b>Cash</b>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div>Exit Value</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="acquisitionExitValue"
                    @keyup="calculateAcquisitionValues('exitValue')"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div>Cash Proceeds</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="acquisitionCashProceeds"
                    @keyup="calculateAcquisitionValues('cashProceeds')"
                    placeholder=""
                    min="0"
                  />
                </div>
                <div class="col-6">
                  <div>Escrow/Holdback</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="acquisitionEscrow"
                    @keyup="calculateAcquisitionValues('escrow')"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div>Recycle $</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="acquisitionRecycle"
                    @keyup="calculateAcquisitionValues('recycle')"
                    placeholder=""
                    min="0"
                  />
                </div>
                <div class="col-6">
                  <div>Distribution</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="acquisitionDistribution"
                    @keyup="calculateAcquisitionValues('distribution')"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>
            </span>

            <span
              v-if="acquisitionType === 'mix' || acquisitionType === 'stock'"
            >
              <div class="row" v-if="acquisitionType === 'mix'">
                <div class="col-12">
                  <b>Stock</b>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div># Of Shares Issued</div>
                  <input
                    type="number"
                    step="1"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="acquisitionSharesIssued"
                    placeholder=""
                    min="0"
                  />
                </div>
                <div class="col-6">
                  <div>Price Per Share (PPS)</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="acquisitionPricePerShare"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div>Ownership %</div>
                  <input
                    type="number"
                    step=".000001"
                    class="form-control team-form"
                    style="width: 100%"
                    v-model="acquisitionOwnershipPercent"
                    placeholder=""
                    min="0"
                  />
                </div>
              </div>
            </span>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div>Transaction Date</div>
                    <input
                      type="date"
                      class="form-control team-form"
                      style="width: 100%"
                      v-model="acquisitionTransactionDate"
                      placeholder=""
                      min="0"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div>Note</div>
                    <textarea
                      placeholder="Note"
                      rows="5"
                      cols="50"
                      class="form-control"
                      spellcheck="false"
                      v-model="acquisitionNote"
                    ></textarea>
                  </div>
                </div>
                <div class="row ipo-files">
                  <div class="col-12">
                    <div style="padding-bottom: 3px">Documents</div>
                    <div class="row m-0">
                      <div
                        class="col-4 attach-class"
                        id="popover-target-1"
                        style="padding-top: 6px; min-width: 130px"
                      >
                        <i class="fa fa-paperclip" aria-hidden="true"></i>
                        Attach a file
                        <input
                          type="file"
                          ref="fileBtn"
                          if="fileId"
                          @change="handleFile"
                          class="hidden"
                        />
                      </div>
                      <b-popover
                        target="popover-target-1"
                        triggers="hover"
                        placement="top"
                        custom-class="popover-modal-class"
                      >
                        <div
                          class="m-2"
                          style="cursor: pointer"
                          @click="
                            $refs.fileBtn.click();
                            ipoTypeUrlCheck = false;
                          "
                        >
                          From Computer
                        </div>
                        <div
                          class="m-2"
                          style="cursor: pointer"
                          @click="ipoTypeUrlCheck = !ipoTypeUrlCheck"
                        >
                          Add Link
                        </div>
                      </b-popover>
                      <div
                        class="col-8 drag-drop-class"
                        style="padding-top: 6px"
                        v-if="!ipoTypeUrlCheck"
                        v-cloak
                        @drop.prevent="addFile"
                        @dragover.prevent
                      >
                        Drag and drop file to attach
                      </div>
                      <div class="col-8" style="padding: 0" v-else>
                        <form @submit.prevent="submitUrl">
                          <input
                            type="text"
                            class="form-control team-form url-input-form"
                            placeholder="Add a URL"
                            id="myInput"
                            @blur="submitUrl"
                            v-model="ipoUrlValue"
                            @
                          />
                        </form>
                      </div>
                    </div>
                    <div class="mt-3">
                      <div v-if="ipoUrl.add">
                        <div
                          v-for="(item, index) in ipoUrl.add"
                          :key="index"
                          class="fileItem my-2"
                        >
                          <a :href="formatUrl(item)" target="_blank">
                            <span class="attachment-name-class">{{
                              item
                            }}</span>
                          </a>
                          <i
                            class="fas fa-times"
                            @click="deleteURL(index, 'add')"
                            style="
                              float: right;
                              padding-top: 5px;
                              margin-right: 18px;
                              cursor: pointer;
                            "
                          ></i>
                        </div>
                      </div>
                      <div v-if="ipoUrl.update">
                        <div
                          v-for="(item, index) in ipoUrl.update"
                          :key="index"
                          class="fileItem my-2"
                        >
                          <a :href="formatUrl(item.url)" target="_blank">
                            <span class="attachment-name-class">{{
                              item.url
                            }}</span>
                          </a>
                          <i
                            class="fas fa-times"
                            @click="deleteURL(index, 'update')"
                            style="
                              float: right;
                              padding-top: 5px;
                              margin-right: 18px;
                              cursor: pointer;
                            "
                          ></i>
                        </div>
                      </div>
                      <div v-if="ipoFiles.add">
                        <div
                          v-for="(item, index) in ipoFiles.add"
                          :key="index"
                          class="d-flex fileItem my-2"
                        >
                          <i
                            v-if="
                              item.type.includes('.doc') ||
                              item.name.includes('.doc') ||
                              item.name.includes('.txt')
                            "
                            class="fas fa-file-word mr-2 mt-1"
                            style="color: #5190ff"
                          ></i>
                          <i
                            v-else-if="
                              item.type.includes('zip') ||
                              item.name.includes('.zip') ||
                              item.type.includes('rar') ||
                              item.name.includes('.rar')
                            "
                            class="far fa-file-archive mr-2 mt-1"
                          ></i>
                          <i
                            v-else-if="item.type.includes('image')"
                            class="fas fa-image mr-2"
                          ></i>
                          <i
                            v-else-if="
                              item.type.includes('csv') ||
                              item.type.includes('xls') ||
                              item.name.includes('.csv') ||
                              item.name.includes('.xls')
                            "
                            class="fas fa-file-excel mr-2 mt-1"
                            style="color: #f15643"
                          ></i>
                          <i
                            v-else-if="
                              item.type.includes('pdf') ||
                              item.type.includes('.pdf')
                            "
                            class="fas fa-file-pdf mr-2 mt-1"
                          ></i>
                          <span
                            class="attachment-name-class"
                            style="cursor: pointer"
                            >{{ item.name }}</span
                          >
                          <i
                            class="fas fa-times"
                            @click="deleteFile(index, 'add')"
                            style="
                              float: right;
                              padding-top: 5px;
                              margin-right: 18px;
                              cursor: pointer;
                            "
                          ></i>
                        </div>
                      </div>
                      <div v-if="ipoFiles.update">
                        <div
                          v-for="(item, index) in ipoFiles.update"
                          :key="index"
                          class="d-flex fileItem my-2"
                        >
                          <i
                            v-if="
                              item.name.includes('.doc') ||
                              item.name.includes('.txt')
                            "
                            style="color: #5190ff"
                            class="fas fa-file-word mr-2 mt-1"
                          ></i>
                          <i
                            v-else-if="
                              item.name.includes('zip') ||
                              item.name.includes('.rar')
                            "
                            class="far fa-file-archive mr-2 mt-1"
                          ></i>
                          <i
                            v-else-if="
                              item.name.includes('.jpg') ||
                              item.name.includes('.png')
                            "
                            class="fas fa-image mr-2 mt-1"
                          ></i>
                          <i
                            v-else-if="
                              item.name.includes('.csv') ||
                              item.name.includes('.xls')
                            "
                            class="fas fa-file-excel mr-2 mt-1"
                            style="color: #f15643"
                          ></i>
                          <i
                            v-else-if="item.name.includes('.pdf')"
                            class="fas fa-file-pdf mr-2"
                          ></i>
                          <span
                            class="attachment-name-class"
                            style="cursor: pointer"
                            @click="handleDownload(item, 's3')"
                            >{{ item.name }}</span
                          >
                          <i
                            class="fas fa-times"
                            @click="deleteFile(index, 'update')"
                            style="
                              float: right;
                              padding-top: 5px;
                              margin-right: 18px;
                              cursor: pointer;
                            "
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="edit-company-action-button-row pt-3"
              style="margin: 0px"
            >
              <button
                type="button"
                @click="handleAcquisitionCancel()"
                class="todo-form-cancel-button btn-outline-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                :disabled="disableAcquisitionCheck"
                class="todo-form-submit-button btn btn-primary"
                style="height: 35px"
              >
                Save
                <b-spinner
                  v-if="isAcquisitionSaving"
                  style="float: right"
                  small
                  label="Loading..."
                ></b-spinner>
              </button>
            </div>
          </div>
        </form>
      </div>
    </el-dialog>

    <a class="hidden" ref="hiddenDownloadAnchor" :href="downloadLink"
      >Download Sample</a
    >
  </div>
</template>
<script>
import _ from "lodash";
import { vals, cbAdapter } from "../../util";
import Card from "./Card.vue";
import moment from "moment";
import api from "../../axios_api";
import EditCompanyDialog from "../../pages/Dashboard/Dialogs/EditCompany";
import { Select, Option, Dialog } from "element-ui";
import ConfirmCard from "./ConfirmCard";
import { Radio } from "src/components/index";
import {
  formatCurrency,
  formatNumber,
  precisionNumberForamtter,
} from "../../util";
import { mapGetters } from "vuex";
import Tabulator from "tabulator-tables";
import config from "../../../config/settings";
import DocumentsCard from "../../components/Cards/DocumentsCard";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { Company } from "../../models/Company";
const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";

export default {
  name: "company-card",
  components: {
    Card,
    [EditCompanyDialog.name]: EditCompanyDialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    ConfirmCard,
    [Radio.name]: Radio,
    [DocumentsCard.name]: DocumentsCard,
    VueBootstrapTypeahead,
  },
  computed: {
    ...mapGetters("user", ["currency"]),
    ...mapGetters("workspacePlans", ["feature", "plan"]),
    ...mapGetters("contacts", ["contactData"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    config() {
      return config;
    },
    emailCheck() {
      if (this.tags.length > 0 && this.invalidTags.length == 0) return false;
      else return true;
    },
    initialInvestment() {
      let tmpII = "";
      if (this.portfolio) {
        let investments = this.$store.getters[
          "investment/investmentsByPortfolioId"
        ](this.portfolio._id);

        if (investments && investments.length) {
          tmpII = moment(investments[0].investment_date).format("MM/DD/YYYY");
        }
      }
      return tmpII;
    },
    lastFunding() {
      let tmp = moment.utc(this.data.last_funding_round).format("L");
      if (this.data && this.data.last_funding_round) {
        tmp = moment(this.data.last_funding_round).format("MM/DD/YYYY");
      }
      return tmp;
    },
    lastFundingType() {
      if (
        this.offerings &&
        this.offerings[0] &&
        this.offerings[0].funding_type
      ) {
        return this.offerings[0].funding_type;
      }
      return "";
    },
    image() {
      return this.data.hasOwnProperty("image_id") &&
        this.data.image_id.length > 0
        ? `${config.CRUNCHBASE_IMAGE_URL}/${this.data.image_id}`
        : _.isNil(this.data.logo_url) || _.isEmpty(this.data.logo_url)
        ? "static/img/generic-logo.png"
        : this.getImageUrl(this.data.logo_url);
    },
    rating() {
      return _.isNil(this.data.rating) ? 0 : this.data.rating;
    },
    starRatings() {
      return `<p style="color: #4338AE;font-size: 11px;">
              <i class="fa fa-star ${this.rating >= 1 ? "" : "hide"}"></i>
              <i class="fa fa-star-o ${this.rating < 1 ? "" : "hide"}"></i>
              <i class="fa fa-star ${this.rating >= 2 ? "" : "hide"}" ></i>
              <i class="fa fa-star-o ${this.rating < 2 ? "" : "hide"}" ></i>
              <i class="fa fa-star ${this.rating >= 3 ? "" : "hide"}"></i>
              <i class="fa fa-star-o ${this.rating < 3 ? "" : "hide"}" ></i>
              <i class="fa fa-star ${this.rating >= 4 ? "" : "hide"}" ></i>
              <i class="fa fa-star-o ${this.rating < 4 ? "" : "hide"}" ></i>
              <i class="fa fa-star ${this.rating >= 5 ? "" : "hide"}" ></i>
              <i class="fa fa-star-o ${this.rating < 5 ? "" : "hide"}" ></i>
          </p>`;
    },
    filterCategoryData() {
      let categoryData;

      if (!categoryData) {
        return "";
      }

      if (typeof this.data.category_data === "string") {
        categoryData = this.data.category_data;
      } else {
        categoryData = JSON.parse(JSON.stringify(this.data.category_data));
      }
      categoryData = categoryData.split(",");
      return Array.from(new Set(categoryData)).toString();
    },
    companyTableFields() {
      this.data.sector =
        this.data.sector == "" || this.data.sector == "Unknown"
          ? "Unknown"
          : this.data.sector;
      this.data.stage_i_invested = this.data.stage_i_invested
        ? this.data.stage_i_invested
        : "-";
      this.data.founding_date = this.data.founding_date
        ? this.data.founding_date
        : "-";
      this.data.initial_investment = this.data.initial_investment
        ? this.data.initial_investment
        : "-";
      this.data.estimated_revenue_range =
        this.data.estimated_revenue_range || "-";
      this.data.direct = this.data.direct ? this.data.direct : "-";
      this.data.ipo_status = this.data.ipo_status ? this.data.ipo_status : "-";
      this.data.fund =
        this.data.fund || this.data.fund != "" ? this.data.fund : "-";
      this.data.status = this.data.status ? this.data.status : "Unknown";
      this.data.company_type = this.data.company_type
        ? this.data.company_type
        : "-";
      this.data.category_data = this.data.category_data
        ? this.data.category_data
        : "-";
      this.data.headquarters = this.data.headquarters
        ? this.data.headquarters
        : "-";
      this.data.geography =
        this.data.geography && this.data.geography != "Unspecified"
          ? this.data.geography
          : "-";
      this.data.website = this.data.website ? this.data.website : "-";
      this.data.facebook = this.data.facebook ? this.data.facebook : "-";
      this.data.linkedin = this.data.linkedin ? this.data.linkedin : "-";
      this.data.twitter = this.data.twitter ? this.data.twitter : "-";
      this.data.contact_email = this.data.contact_email
        ? this.data.contact_email
        : "-";
      this.data.lastFunding = this.data.last_funding_round
        ? this.data.last_funding_round
        : "-";
      return [
        {
          label: "Stage I invested:",
          value: this.data.stage_i_invested,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Founding Date:",
          value:
            this.data.founding_date &&
            this.data.founding_date != "-" &&
            this.data.founding_date != "Invalid date"
              ? moment(this.data.founding_date).format("MM/DD/YYYY")
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        // {
        //   label: "Company Type:",
        //   value: this.data.company_type,
        //   isEditOn: false,
        //   isEditable: false
        // },
        {
          label: "Geography:",
          value: this.data.geography,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Headquarters:",
          value: this.data.headquarters,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "No. of Employees:",
          value: this.data.employee_count || "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Website:",
          value:
            this.data.website && this.data.website != "-"
              ? `<a class="link" href="${this.data.website}" target="_blank">${this.data.website}</a>`
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Contact Email:",
          value:
            this.data.contact_email && this.data.contact_email != "-"
              ? `<a class="link" style="color: #0000009A;" href="mailto:${this.data.contact_email}">${this.data.contact_email}</a>`
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Social Media:",
          value: this.socialMedia,
          isEditOn: false,
          isEditable: false,
        },
      ];
    },
    socialMedia() {
      let html = "";
      if (
        (this.data.facebook && this.data.facebook != "-") ||
        (this.data.linkedin && this.data.linkedin != "-") ||
        (this.data.twitter && this.data.twitter != "-")
      ) {
        let facebook =
          this.data.facebook && this.data.facebook != "-"
            ? `<div>
          <a class="link" href="${this.data.facebook}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-facebook-square" aria-hidden="true"></i>
          </a>
          </div>`
            : "";
        let linkedin =
          this.data.linkedin && this.data.linkedin != "-"
            ? `<div>
          <a class="link" href="${this.data.linkedin}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-linkedin-square" aria-hidden="true"></i>
          </a> 
          </div>`
            : "";
        let twitter =
          this.data.twitter && this.data.twitter != "-"
            ? `<div>
          <a class="link" href="${this.data.twitter}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-twitter-square" aria-hidden="true"></i>
          </a>
          </div>`
            : "";
        html = `<div class="d-flex">
          ${facebook && facebook.length > 0 ? facebook : ""}
          ${linkedin && linkedin.length > 0 ? linkedin : ""}
          ${twitter && twitter.length > 0 ? twitter : ""} 
          </div>`;
      } else {
        html = `<div style="color:#0000009A;font-size:18px">-</div>`;
      }
      return html;
    },
    statusBadge() {
      let obj = {};
      this.data.status = this.data.status ? this.data.status : "Unknown";
      obj.value = this.data.status;
      if (
        this.data.status == "Active" ||
        this.data.status == "Unknown" ||
        this.data.status == "Mentor" ||
        this.data.status == "Exit"
      ) {
        obj.style =
          "margin-top:2px;background: #CBF6C5 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.data.status == "Out of Business") {
        obj.value = "OB";
        obj.style =
          "margin-top:2px;background: #FACCCC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.data.status == "IPO") {
        obj.style =
          "margin-top:2px;background: #FFDFB4 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.data.status == "Acquired") {
        obj.style =
          "margin-top:2px;background: #B4DCFF 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else {
        obj.style =
          "margin-top:2px;background: #FFDFB4 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      }
      return obj;
    },
    state() {
      return this.dirty ? this.tags.length > 0 && this.tags.length < 10 : null;
    },
    tractionTableFields() {
      let array = [];
      if (
        this.tractionData &&
        this.tractionData.length > 0 &&
        this.tractionData[0].created
      ) {
        this.$store.commit(
          "charts/setTractionLastUpdatedDate",
          this.tractionData[0].created
        );
      }
      if (
        this.data &&
        this.data.user_investment_status &&
        this.data.user_investment_status == "Invested"
      ) {
        array = [
          {
            label: "Updated By:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].source
                ? this.tractionData[0].source
                : "-",
          },
          {
            label: "Updated on:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].created
                ? moment(this.tractionData[0].created).format("MM/DD/YYYY")
                : "-",
          },
          {
            label: "Cash on Hand:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].cash
                ? `$${precisionNumberForamtter(this.tractionData[0].cash, 1)}`
                : "-",
          },
          {
            label: "Monthly Burn:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].monthlyBurn
                ? `$${precisionNumberForamtter(
                    this.tractionData[0].monthlyBurn,
                    1
                  )}`
                : "-",
          },
          {
            label: "Runway (Months):",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].runway
                ? this.tractionData[0].runway
                : "-",
          },
          {
            label: "Cash Out Date:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].cashOutDate
                ? moment(this.tractionData[0].cashOutDate).format("MM/DD/YYYY")
                : "-",
          },
          {
            label: "MRR:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].mrr
                ? `$${precisionNumberForamtter(this.tractionData[0].mrr, 1)}`
                : "-",
          },
          {
            label: "ARR:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].arr
                ? `$${precisionNumberForamtter(this.tractionData[0].arr, 1)}`
                : "-",
          },
          {
            label: "Other Types of Revenue:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].revenue
                ? `$${precisionNumberForamtter(
                    this.tractionData[0].revenue,
                    1
                  )}`
                : "-",
          },
          {
            label: "No. of Paying Customers:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].payingCustomers
                ? precisionNumberForamtter(
                    this.tractionData[0].payingCustomers,
                    1
                  )
                : "-",
          },
          {
            label: "Number of Customers:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].customers
                ? precisionNumberForamtter(this.tractionData[0].customers, 1)
                : "-",
          },
          {
            label: "Type of Contract:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].contractType
                ? this.tractionData[0].contractType
                : "-",
          },
        ];
      } else {
        array = [
          {
            label: "No. of Paying Customers:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].payingCustomers
                ? precisionNumberForamtter(
                    this.tractionData[0].payingCustomers,
                    1
                  )
                : "-",
          },
          {
            label: "Number of Customers:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].customers
                ? precisionNumberForamtter(this.tractionData[0].customers, 1)
                : "-",
          },
          {
            label: "Type of Contract:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].contractType
                ? this.tractionData[0].contractType
                : "-",
          },
          {
            label: "MRR:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].mrr
                ? `$${precisionNumberForamtter(this.tractionData[0].mrr, 1)}`
                : "-",
          },
          {
            label: "ARR:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].arr
                ? `$${precisionNumberForamtter(this.tractionData[0].arr, 1)}`
                : "-",
          },
          {
            label: "Other Types of Revenue:",
            value:
              this.tractionData &&
              this.tractionData.length > 0 &&
              this.tractionData[0].revenue
                ? `$${precisionNumberForamtter(
                    this.tractionData[0].revenue,
                    1
                  )}`
                : "-",
          },
        ];
      }
      if(array[0].label === "Updated By:" && array[0].value === "Company"){
        this.isUpdatedByCompany = true
      }else{
        this.isUpdatedByCompany = false;
      }
      return array;
    },
    showTractionCard() {
      let featureIndex = this.feature.findIndex((item) => {
        if (item == "TRACTION") return item;
      });
      if (featureIndex >= 0) return true;
      else return false;
    },
    showAddIcon() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD KPI") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showDeleteCompany() { 
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      if (
        this.data.user_investment_status &&
        this.data.user_investment_status != "Diligence"
      ) {
        let index = rolePermissions.findIndex((item) => {
          if (item == "DELETE PORTFOLIO") {
            return item;
          }
        });
        return index >= 0 ? true : false;
      } else {
        let index = rolePermissions.findIndex((item) => {
          if (item == "DELETE DILIGENCE") {
            return item;
          }
        });
        return index >= 0 ? true : false;
      }
    },
    showEditCompany() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "EDIT COMPANY") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    historyTableData() {
      if (this.data && this.data._id) {
        let retval = this.$store.getters["charts/companyTractionData"](
          this.data._id
        );
        return retval && retval.length > 0
          ? JSON.parse(JSON.stringify(retval))
          : [];
      }
    },
    historyTableColumns() {
      let self = this;
      return [
        {
          title: "Date Received",
          field: "created",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("created") && data.created.length > 0
              ? moment(data.created).format("MM/DD/YYYY")
              : moment(new Date()).format("MM/DD/YYYY");
          },
        },
        {
          title: "Updated By",
          field: "source",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("source") && data.source.length > 0
              ? data.source
              : "Manual";
          },
        },
        {
          title: "Cash on Hand",
          field: "cash",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("cash") && data.cash
              ? `$${precisionNumberForamtter(data.cash, 1)}`
              : "$0";
          },
        },
        {
          title: "Monthly Burn",
          field: "monthlyBurn",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("monthlyBurn") && data.monthlyBurn
              ? `$${precisionNumberForamtter(data.monthlyBurn, 1)}`
              : "$0";
          },
        },
        {
          title: "Runway (Months)",
          field: "runway",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("runway") && data.runway
              ? data.runway
              : 0;
          },
        },
        {
          title: "Cash Out Date",
          field: "cashOutDate",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("cashOutDate") &&
              data.cashOutDate.length > 0
              ? moment(data.cashOutDate).format("MM/DD/YYYY")
              : moment(new Date()).format("MM/DD/YYYY");
          },
        },
        {
          title: "MRR",
          field: "mrr",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("mrr") && data.mrr
              ? `$${precisionNumberForamtter(data.mrr, 1)}`
              : "$0";
          },
        },
        {
          title: "ARR",
          field: "arr",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("arr") && data.arr
              ? `$${precisionNumberForamtter(data.arr, 1)}`
              : "$0";
          },
        },
        {
          title: "Other Types of Revenue",
          field: "revenue",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("revenue") && data.revenue
              ? `$${precisionNumberForamtter(data.revenue, 1)}`
              : "$0";
          },
        },
        {
          title: "No. of Paying Customers",
          field: "payingCustomers",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("payingCustomers") &&
              data.payingCustomers
              ? data.payingCustomers
              : 0;
          },
        },
        {
          title: "Number of Customers",
          field: "customers",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("customers") && data.customers
              ? data.customers
              : 0;
          },
        },
        {
          title: "Type of Contract",
          field: "contractType",
          sorter: "string",
          headerSort: false,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("contractType") &&
              data.contractType.length > 0
              ? data.contractType
              : "-";
          },
        },
        {
          title: "",
          field: "",
          sorter: "string",
          width: 20,
          headerSort: false,
          resizable: false,
          cellClick: function (e, cell) {
            if (
              cell.getData().hasOwnProperty("source") &&
              cell.getData().source.length > 0 &&
              cell.getData().source == "Manual"
            ) {
              self.handleEditKPI([cell.getData()]);
            }
          },
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return data.hasOwnProperty("source") &&
              data.source.length > 0 &&
              data.source == "Manual"
              ? `<img src="static/img/tractionEdit.svg" class=""/>`
              : "";
          },
          visible: self.showAddIcon,
        },
      ];
    },
    disableIPOCheck() {
      let self = this;

      return self.isIPOSaving;
    },

    ipoLockupEndDate() {
      let self = this;
      if (self.ipoLockUpStartDate) {
        if (!self.ipoPeriod) {
          return moment(self.ipoLockUpStartDate).format("MM/DD/YYYY");
        }

        return moment(self.ipoLockUpStartDate)
          .add(self.ipoPeriod, "days")
          .format("MM/DD/YYYY");
      }

      return "add period and lockup start date.";
    },

    disableAcquisitionCheck() {
      let self = this;

      return self.isAcquisitionSaving;
    },
  },
  mounted() {
    if (this.data && this.data.organization) {
      this.getPeopleData();
    }
    if (this.data && this.data._id) {
      this.getTractionData();
    }
    var dataDesc = this.data.description;
    this.companyDesc =
      dataDesc && dataDesc.length > 200 ? dataDesc.substr(0, 200) : dataDesc;
  },
  methods: {
    onTagState(valid, invalid, duplicate) {
      this.validTags = valid;
      this.invalidTags = invalid;
      this.duplicateTags = duplicate;
    },
    getPeopleData() {
      const self = this;
      api
        .get(`portfolio/peoples/${self.data._id}`)
        .then((data) => {
          self.peopleData = data.data.encrypt.success;
          self.investors = _.filter(self.peopleData, function (o) {
            return (
              o.context === "investor" && o.portfolio_item === self.data._id
            );
          });
          self.employees = _.filter(self.peopleData, function (o) {
            return (
              o.context === "employee" && o.portfolio_item === self.data._id
            );
          });
          self.advisors = _.filter(self.peopleData, function (o) {
            return (
              o.context === "advisor" && o.portfolio_item === self.data._id
            );
          });
          self.founders = _.filter(self.peopleData, function (o) {
            return (
              o.context === "founder" && o.portfolio_item === self.data._id
            );
          });
          if (self.founders) {
            self.founderArray =
              self.founders.length > 2
                ? [self.founders[0], self.founders[1], self.founders[2]]
                : self.founders;
          }
          if (self.investors) {
            self.investorArray =
              self.investors.length > 4
                ? [
                    self.investors[0],
                    self.investors[1],
                    self.investors[2],
                    self.investors[3],
                    self.investors[4],
                  ]
                : self.investors;
          }
          if (self.advisors) {
            self.advisorArray =
              self.advisors.length > 3
                ? [
                    self.advisors[0],
                    self.advisors[1],
                    self.advisors[2],
                    self.advisors[3],
                  ]
                : self.advisors;
          }
          if (self.employees) {
            self.employeeArray =
              self.employees.length > 3
                ? [
                    self.employees[0],
                    self.employees[1],
                    self.employees[2],
                    self.employees[3],
                  ]
                : self.employees;
          }
        })
        .catch((err) => console.log(err));
    },
    descriptionClick(text) {
      this.companyDesc = "";
      if (text == "more") {
        this.companyDesc = this.data.description;
      } else {
        this.companyDesc =
          this.data.description && this.data.description.length > 200
            ? this.data.description.substr(0, 200)
            : this.data.description;
      }
    },
    founderclick(context, text) {
      if (context == "founder") {
        this.founderArray = [];
        if (text == "more") {
          this.founderArray = JSON.parse(JSON.stringify(this.founders));
        } else {
          this.founderArray =
            this.founders.length > 2
              ? [this.founders[0], this.founders[1], this.founders[2]]
              : this.founders;
        }
      }
      if (context == "investor") {
        this.investorArray = [];
        if (text == "more") {
          this.investorArray = JSON.parse(JSON.stringify(this.investors));
        } else {
          this.investorArray =
            this.investors.length > 4
              ? [
                  this.investors[0],
                  this.investors[1],
                  this.investors[2],
                  this.investors[3],
                  this.investors[4],
                ]
              : this.investors;
        }
      }
      if (context == "advisor") {
        this.advisorArray = [];
        if (text == "more") {
          this.advisorArray = JSON.parse(JSON.stringify(this.advisors));
        } else {
          this.advisorArray =
            this.advisors.length > 3
              ? [
                  this.advisors[0],
                  this.advisors[1],
                  this.advisors[2],
                  this.advisors[3],
                ]
              : this.advisors;
        }
      }
      if (context == "employee") {
        this.employeeArray = [];
        if (text == "more") {
          this.employeeArray = JSON.parse(JSON.stringify(this.employees));
        } else {
          this.employeeArray =
            this.employees.length > 3
              ? [
                  this.employees[0],
                  this.employees[1],
                  this.employees[2],
                  this.employees[3],
                ]
              : this.employees;
        }
      }
    },
    setPopoverData(item, index) {
      this.employeePopover = item;
      this.employeeTargert = `peoplePopover${item._id}${index}`;
      this.investedCompanies = [];
      this.exits = 0;
      this.num_portfolio_organization = 0;
      let obj = this.contactData.find(
        (contactItem) => contactItem.master_pid == item.master_pid
      );
      if (obj) {
        this.exits = obj.num_exits;
        this.num_portfolio_organization = obj.num_portfolio_organization;
        this.investedCompanies = obj.investedCompanies;
      }
    },
    handleEditCompany() {
      let propsData = JSON.parse(JSON.stringify(this.data));
      propsData.initial_investment =
        propsData.initial_investment && propsData.initial_investment != "-"
          ? propsData.initial_investment
          : "";
      propsData.name =
        propsData.name && propsData.name != "-" ? propsData.name : "";
      propsData.logo_url =
        propsData.logo_url && propsData.logo_url != "-"
          ? propsData.logo_url
          : "";
      propsData.category_data =
        propsData.category_data && propsData.category_data != "-"
          ? Array.from(new Set(propsData.category_data.split(","))).toString()
          : "";
      propsData.sector =
        propsData.sector && propsData.sector != "-" ? propsData.sector : "";
      propsData.founding_date =
        propsData.founding_date && propsData.founding_date != "-"
          ? propsData.founding_date
          : "";
      propsData.stage_i_invested =
        propsData.stage_i_invested && propsData.stage_i_invested != "-"
          ? propsData.stage_i_invested
          : "";
      propsData.company_type =
        propsData.company_type && propsData.company_type != "-"
          ? propsData.company_type
          : "";
      propsData.geography =
        propsData.geography && propsData.geography != "-"
          ? propsData.geography
          : "";
      propsData.employee_count =
        propsData.employee_count && propsData.employee_count != "-"
          ? propsData.employee_count
          : "";
      propsData.website =
        propsData.website && propsData.website != "-" ? propsData.website : "";
      propsData.contact_email =
        propsData.contact_email && propsData.contact_email != "-"
          ? propsData.contact_email
          : "";
      propsData.facebook =
        propsData.facebook && propsData.facebook != "-"
          ? propsData.facebook
          : "";
      propsData.linkedin =
        propsData.linkedin && propsData.linkedin != "-"
          ? propsData.linkedin
          : "";
      propsData.twitter =
        propsData.twitter && propsData.twitter != "-" ? propsData.twitter : "";
      propsData.description =
        propsData.description && propsData.description != "-"
          ? propsData.description
          : "";
      propsData.referred_by = this.referrals;
      // this.$refs.editCompanyRef.$refs.referralRef.inputValue =
      //   this.referrals && this.referralsData ? this.referralsData.name : "";
      this.editCompanyModalProps = {
        isShow: true,
        data: propsData,
      };
      this.showEditModalPopup = true;
    },
    companySave() {
      this.$emit("company-save", {});
    },
    downloadAsPdf() {
      let data = JSON.parse(JSON.stringify(this.downloadProps));
      data.pdfType = "Download as Pdf";
      this.$toaster.success("Download In-progress...");
      api.post("/file/uploadEmail", { encrypt: { data: data } }).then((res) => {
        this.$toaster.success("Download Completed");
        return window.open(res.data.encrypt.success);
      });
    },
    tagValidator(tag) {
      let value = tag.length > 5 && tag.includes("@") && tag.includes(".");
      return value;
    },
    sendEmail() {
      this.submit = true;
      let data = JSON.parse(JSON.stringify(this.downloadProps));
      data.pdfType = "Send Email";
      data.recieverEmail = this.tags.toString();
      data.sharingNote = this.sharingNote;
      api.post("/file/uploadEmail", { encrypt: { data: data } }).then((res) => {
        this.$toaster.success("Email will be sent shortly...");
        this.submit = false;
        this.modalShow = false;
        this.tags = [];
      });
    },
    deleteCompany() {
      const self = this;
      // need to delete 3 things
      // 1 portfolio data associated with company
      // 2 people associated with company
      // 3 attachments/docs associated with the company
      // 4 company itself

      // assume successful delete, next people...
      let dilignceItem;
      if (!self.data.diligenceId) {
        let diligenceData = this.$store.getters["diligence/diligenceData"];
        dilignceItem = diligenceData.find(
          (item) => item.portfolio_item == self.data._id
        );
      }
      api
        .delete(
          `${self.$route.params.account_id}/${self.$route.params.workspace_id}/company/investment/${self.data.ucid}`
        )
        .then((data) => {})
        .catch((err) => {
          console.log(err);
        });
      return self.$store
        .dispatch("people/removeCompany", {
          ucid: self.data.ucid,
        })
        .then((res) => {
          if (self.data.diligenceId || (dilignceItem && dilignceItem._id)) {
            return self.$store.dispatch("diligence/apiDeleteDiligence", {
              ucid: self.data.ucid,
              _id:
                self.data && self.data.diligenceId
                  ? self.data.diligenceId
                  : dilignceItem._id,
            });
          } else return;
        })
        .then((res) => {
          // delete all attachments
          // delete all investments
          return self.$store.dispatch("investment/removeCompany", {
            ucid: self.data.ucid,
          });
        })
        .then((res) => {
          // delete all attachments
          return self.$store.dispatch("attachment/removeCompany", {
            ucid: self.data.ucid,
          });
        })
        .then((res) => {
          // delete all attachments
          return self.$store.dispatch("file/removeCompany", {
            ucid: self.data.ucid,
          });
        })
        .then((res) => {
          // assume successful delete, finally company...
          return self.$store.dispatch("portfolio/apiDeletePortfolio", {
            ucid: self.data.ucid,
            _id: self.data._id,
          });
        })
        .then((res) => {
          return self.$store.dispatch("offering/apiDeletePortfolioOfferings", {
            ucid: self.data.ucid,
          });
        })
        .then((res) => {
          let payload = {};
          if (self.data.user_investment_status == "Diligence") {
            payload.diligence_id =
              self.data && self.data.diligenceId
                ? self.data.diligenceId
                : dilignceItem._id;
          } else {
            payload.portfolio_item = self.data._id;
          }
          return self.$store.dispatch("portfolio/apiDeleteReferrers", payload);
        })
        .then((res) => {
          self.$store.dispatch("portfolio/_apiFetchPortfolio");
        })
        .then((res) => {
          return self.$store.dispatch("referrer/start");
        })
        .then((res) => {
          return self.$store.dispatch("contacts/start");
        })
        .then((res) => {
          // done, company should be erased, go back
          //self.modals[DELETEPROMPT] = false;
          //self.updateDisplay++;
          self.showDeleteModal = false;
          if (self.data.diligenceId || (dilignceItem && dilignceItem._id)) {
            this.$store
              .dispatch("diligence/apiCleanFetchDiligence")
              .then((data) => {
                if (self.data.diligenceId) {
                  window.sessionStorage.setItem(
                    "diligence_id",
                    self.data.diligenceId
                  );
                } else if (dilignceItem && dilignceItem._id) {
                  window.sessionStorage.setItem(
                    "diligence_id",
                    dilignceItem._id
                  );
                }
                this.$toaster.success("Deleted Successfully");
                self.$router.go(-1);
              });
          } else {
            this.$toaster.success("Deleted Successfully");
            self.$router.go(-1);
          }
        })
        .catch((err) => {
          console.error(`Error during delete process, aborting... ${err}`);
          // go back to investments
          //self.modals[DELETEPROMPT] = false;
          self.updateDisplay++;
          if (self.data.diligenceId || dilignceItem) {
            this.$store
              .dispatch("diligence/apiCleanFetchDiligence")
              .then((data) => {
                this.$toaster.success("Deleted Successfully");
                self.$router.go(-1);
              });
          } else {
            this.$toaster.success("Deleted Successfully");
            self.$router.go(-1);
          }
        });
    },
    handleCancelDeleteCompany() {
      this.showDeleteModal = false;
    },
    closeModal(ctx, eventData) {
      const self = this;
      if (!_.isNil(eventData) && eventData.confirm) {
        // delete the company and related data
        self.deleteCompany();
      } else {
        self.showDeleteModal = false;
      }
    },
    getTractionData() {
      const self = this;
      api
        .get(`/${self.$route.params.workspace_id}/${self.data._id}/traction`)
        .then((data) => {
          if (
            data &&
            data.data &&
            data.data.encrypt &&
            data.data.encrypt.success
          ) {
            self.tractionData = data.data.encrypt.success;
            self.$store.commit(
              "charts/setPortfolioTractionData",
              self.tractionData
            );
          }
        })
        .catch((error) => {
          console.log("error in fetching traction details", error);
        });
    },
    handleCancel() {
      this.isShow = false;
      this.showSpinner = false;
      this.editTractionData = {};
      this.editTractionDataRunway = 0;
      this.editTractionDataCashOutDate = "";
      this.editTractionDataContractType = "";
      this.isEditKpi = false;
    },
    writeToServer() {
      this.showSpinner = true;
      let serverData = JSON.parse(JSON.stringify(this.editTractionData));
      serverData.cash = serverData.cash ? Number(serverData.cash) : 0;
      serverData.monthlyBurn = serverData.monthlyBurn
        ? Number(serverData.monthlyBurn)
        : 0;
      serverData.mrr = serverData.mrr ? Number(serverData.mrr) : 0;
      serverData.arr = serverData.arr ? Number(serverData.arr) : 0;
      serverData.revenue = serverData.revenue ? Number(serverData.revenue) : 0;
      serverData.payingCustomers = serverData.payingCustomers
        ? Number(serverData.payingCustomers)
        : 0;
      serverData.customers = serverData.customers
        ? Number(serverData.customers)
        : 0;
      serverData.runway = this.editTractionDataRunway;
      serverData.cashOutDate = this.editTractionDataCashOutDate;
      serverData.contractType = this.editTractionDataContractType
        ? this.editTractionDataContractType
        : "";
      serverData.user_investment_status = this.data.user_investment_status;
      serverData.churn = serverData.churn ? Number(serverData.churn) : 0;
      serverData.churnPercentage =
        serverData.churn && serverData.customers
          ? Number(
              (
                (Number(serverData.customers) - Number(serverData.churn)) /
                100
              ).toFixed(2)
            )
          : 0;
      serverData.created = this.editTractionDataDate
        ? this.editTractionDataDate
        : new Date();
      if (this.data && this.data._id) {
        if (!this.isEditKpi) {
          api
            .post(
              `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/${this.data._id}/traction`,
              {
                encrypt: {
                  data: serverData,
                },
              }
            )
            .then((data) => {
              if (
                data &&
                data.data &&
                data.data.encrypt &&
                data.data.encrypt.success
              ) {
                this.$store.dispatch("charts/getTractionData");
                //this.tractionData = data.data.encrypt.success;
                this.getTractionData();
                this.$store.commit(
                  "charts/setPortfolioTractionData",
                  this.tractionData
                );
                this.handleCancel();
                this.$toaster.success("Saved successfully.");
              }
            })
            .catch((error) => {
              console.log("error in traction data insert", error);
              this.$toaster.error("Fail to edit");
            });
        } else {
          if (serverData._id) {
            api
              .patch(
                `/${this.$route.params.account_id}/${serverData._id}/traction`,
                {
                  encrypt: {
                    data: serverData,
                  },
                }
              )
              .then((data) => {
                this.getTractionData();
                this.$store
                  .dispatch("charts/getTractionData")
                  .then((chartsTractionData) => {
                    this.showHistoryTableModal = false;
                    this.handleCancel();
                    this.$toaster.success("Saved successfully.");
                  })
                  .catch((chartsTractionError) => {
                    console.log(
                      "error in charts/getTractionData inside traction data edit",
                      chartsTractionError
                    );
                    this.handleCancel();
                    this.$toaster.success("Saved successfully.");
                  });
              })
              .catch((error) => {
                console.log("error in traction data edit", error);
                this.$toaster.error("Fail to edit");
              });
          }
        }
      }
    },
    handleEditCurrentKPI() {
      this.editTractionData = {};
      this.editTractionDataDate = moment(new Date()).format("YYYY-MM-DD");
      this.isEditKpi = false;
      if (this.tractionData.length > 0) {
        this.editTractionData.cash = this.tractionData[0].cash
          ? this.tractionData[0].cash
          : 0;
        this.editTractionData.monthlyBurn = this.tractionData[0].monthlyBurn
          ? this.tractionData[0].monthlyBurn
          : 0;
        this.editTractionData.runway = this.tractionData[0].runway
          ? this.tractionData[0].runway
          : 0;
        this.editTractionData.cashOutDate = this.tractionData[0].cashOutDate
          ? this.tractionData[0].cashOutDate
          : "";
        this.editTractionData.mrr = this.tractionData[0].mrr
          ? this.tractionData[0].mrr
          : 0;
        this.editTractionData.arr = this.tractionData[0].arr
          ? this.tractionData[0].arr
          : 0;
        this.editTractionData.revenue = this.tractionData[0].revenue
          ? this.tractionData[0].revenue
          : 0;
        this.editTractionData.payingCustomers = this.tractionData[0]
          .payingCustomers
          ? this.tractionData[0].payingCustomers
          : 0;
        this.editTractionData.customers = this.tractionData[0].customers
          ? this.tractionData[0].customers
          : 0;
        this.editTractionData.contractType = this.tractionData[0].contractType
          ? this.tractionData[0].contractType
          : "";
        this.editTractionDataRunway = this.tractionData[0].runway
          ? this.tractionData[0].runway
          : 0;
        this.editTractionDataCashOutDate = this.tractionData[0].cashOutDate
          ? this.tractionData[0].cashOutDate
          : "";
        this.editTractionDataCashOutDate = moment(
          this.editTractionDataCashOutDate
        ).format("yyyy-MM-DD");
        this.editTractionDataContractType = this.tractionData[0].contractType
          ? this.tractionData[0].contractType
          : "";
        this.editTractionData.churn = this.tractionData[0].churn
          ? this.tractionData[0].churn
          : 0;
        this.editTractionDataDate =
          this.tractionData[0].hasOwnProperty("created") &&
          this.tractionData[0].created
            ? moment(this.tractionData[0].created).format("YYYY-MM-DD")
            : moment(new Date()).format("YYYY-MM-DD");
      }
      this.isShow = true;
    },
    setRunwayAndCashOutDate() {
      const self = this;
      self.editTractionDataRunway = 0;
      self.editTractionDataCashOutDate = "";
      if (this.editTractionData.cash && this.editTractionData.monthlyBurn) {
        // setTimeout(() => {
        self.editTractionDataRunway =
          Number(self.editTractionData.cash) /
          Number(self.editTractionData.monthlyBurn);
        self.editTractionDataCashOutDate = new Date(
          new Date().setMonth(
            new Date().getMonth() +
              Math.round(Number(self.editTractionDataRunway))
          )
        );
        self.editTractionDataCashOutDate = moment(
          self.editTractionDataCashOutDate
        ).format("yyyy-MM-DD");
        //}, 500);
      }
    },
    handleHistory() {
      this.showHistoryTableModal = true;
      let self = this;
      setTimeout(() => {
        self.historyTabulator = new Tabulator(self.$refs.historyTabulator, {
          layout: "fitColumns",
          index: "_id",
          tooltips: true,
          data: self.historyTableData,
          columns: self.historyTableColumns,
          tooltips: true,
          pagination: "local",
          // paginationSize: 3,
          // paginationSizeSelector: true,
          placeholder: "No records to view",
        });
      }, 100);
    },
    handleEditKPI(tractionData) {
      this.editTractionData = {};
      this.editTractionDataDate = moment(new Date()).format("YYYY-MM-DD");
      this.isEditKpi = true;
      if (tractionData.length > 0) {
        this.editTractionData.cash = tractionData[0].cash
          ? tractionData[0].cash
          : 0;
        this.editTractionData.monthlyBurn = tractionData[0].monthlyBurn
          ? tractionData[0].monthlyBurn
          : 0;
        this.editTractionData.runway = tractionData[0].runway
          ? tractionData[0].runway
          : 0;
        this.editTractionData.cashOutDate = tractionData[0].cashOutDate
          ? tractionData[0].cashOutDate
          : "";
        this.editTractionData.mrr = tractionData[0].mrr
          ? tractionData[0].mrr
          : 0;
        this.editTractionData.arr = tractionData[0].arr
          ? tractionData[0].arr
          : 0;
        this.editTractionData.revenue = tractionData[0].revenue
          ? tractionData[0].revenue
          : 0;
        this.editTractionData.payingCustomers = tractionData[0].payingCustomers
          ? tractionData[0].payingCustomers
          : 0;
        this.editTractionData.customers = tractionData[0].customers
          ? tractionData[0].customers
          : 0;
        this.editTractionData.contractType = tractionData[0].contractType
          ? tractionData[0].contractType
          : "";
        this.editTractionDataRunway = tractionData[0].runway
          ? tractionData[0].runway
          : 0;
        this.editTractionDataCashOutDate = tractionData[0].cashOutDate
          ? tractionData[0].cashOutDate
          : "";
        this.editTractionDataCashOutDate = moment(
          this.editTractionDataCashOutDate
        ).format("yyyy-MM-DD");
        this.editTractionDataContractType = tractionData[0].contractType
          ? tractionData[0].contractType
          : "";
        this.editTractionData.churn = tractionData[0].churn
          ? tractionData[0].churn
          : 0;
        this.editTractionDataDate =
          tractionData[0].hasOwnProperty("created") && tractionData[0].created
            ? moment(tractionData[0].created).format("YYYY-MM-DD")
            : moment(new Date()).format("YYYY-MM-DD");
        this.editTractionData._id = tractionData[0]._id
          ? tractionData[0]._id
          : "";
      }
      this.isShow = true;
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },

    confirmStatusChange() {
      this.changeStatus();
      this.showConfirmModal = false;
    },
    cancelConfirmStatusChange() {
      let self = this;
      self.statusBadge.value = this.data.status;
      self.statusConfirmMessage = ``;
      self.showConfirmModal = false;
    },

    changeStatus() {
      let self = this;

      if (self.statusBadge.value === "IPO") {
        self.statusBadge.value = this.data.status;
        self.showIPODialog = true;
        return;
      }

      if (self.statusBadge.value === "Acquired") {
        self.statusBadge.value = this.data.status;
        self.showAcquisitionDialog = true;
        return;
      }

      api
        .patch(
          `${self.$route.params.account_id}/${self.$route.params.workspace_id}/portfolio/${self.data.ucid}/status`,
          {
            encrypt: {
              data: {
                statusData: { status: self.statusBadge.value },
                portfolio: self.data,
              },
            },
          }
        )
        .then((data) => {
          self.$store.dispatch("portfolio/_apiFetchPortfolio").then((res) => {
            self.$toaster.success("Saved successfully.");
          });
        })
        .catch((err) => {
          console.log(err);
          self.$toaster.error("Fail to edit");
        });
    },

    handleStatusChange(el) {
      let self = this;

      if (self.statusBadge.value === "IPO") {
        if (this.data.status === "Acquired") {
          // show confirmation
          self.statusConfirmMessage = `
          By changing the status, the Acquisition data will be 
          lost. Do you want to proceed?`;
          self.showConfirmModal = true;
          return;
        }

        self.changeStatus();
        return;
      }

      if (self.statusBadge.value === "Acquired") {
        if (this.data.status === "IPO") {
          // show confirmation
          self.statusConfirmMessage = `
          By changing the status, the IPO data will be 
          lost. Do you want to proceed?`;
          self.showConfirmModal = true;
          return;
        }

        self.changeStatus();
        return;
      }

      if (
        this.data.status === "Acquired" &&
        !["In-Active", "Out of Business", "Unknown"].includes(
          self.statusBadge.value
        )
      ) {
        // show confirmation
        self.statusConfirmMessage = `
          By changing the status, the Acquisition data will be 
          lost. Do you want to proceed?`;
        self.showConfirmModal = true;
        return;
      }
      if (
        this.data.status === "IPO" &&
        !["In-Active", "Out of Business", "Unknown"].includes(
          self.statusBadge.value
        )
      ) {
        // show confirmation
        self.statusConfirmMessage = `
          By changing the status, the IPO data will be 
          lost. Do you want to proceed?`;
        self.showConfirmModal = true;
        return;
      }

      self.changeStatus();
    },

    async handleDownload(item, type) {
      if (type == "s3") {
        let self = this;
        let urlData = await api
          .post(`/file/download`, {
            encrypt: {
              data: {
                s3_path: item.s3_path,
              },
            },
          })
          .catch((e) => {
            console.error("error: ", e);
          });

        if (
          urlData &&
          urlData.data &&
          urlData.data.encrypt &&
          urlData.data.encrypt.url
        ) {
          // window.open(urlData.data.encrypt.url);
          this.downloadLink = urlData.data.encrypt.url;

          setTimeout(() => {
            self.$refs.hiddenDownloadAnchor.click();
          });
        }
      }
    },

    async deleteFiles() {
      let self = this;

      let fileDelete = [...this.ipoFiles.delete, ...this.ipoUrl.delete];

      if (!fileDelete.length) {
        return;
      }

      for (let i = 0; i < fileDelete.length; i++) {
        if (fileDelete[i]) {
          await self.$store.dispatch("file/deleteFile", fileDelete[i]._id);
        }
      }

      self.$store.dispatch("file/start", null, { root: true });
    },

    deleteFile(index, type) {
      if (type == "add") this.ipoFiles.add.splice(index, 1);
      else {
        let data = this.ipoFiles.update.splice(index, 1);
        this.ipoFiles.delete.push(data[0]);
      }
    },
    deleteURL(index, type) {
      if (type == "add") this.ipoUrl.add.splice(index, 1);
      else {
        let data = this.ipoUrl.update.splice(index, 1);
        this.ipoUrl.delete.push(data[0]);
      }
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.ipoFiles.add.push(f);
      });
    },

    handleFile(e) {
      let droppedFiles = e.target.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.ipoFiles.add.push(f);
      });
    },
    formatUrl(url) {
      // make sure it starts w/ http(s)
      if (url.length > 1) {
        if (!url.startsWith("https")) url = "https://" + url;
        return url;
      } else return "";
    },
    submitUrl() {
      this.ipoUrlValue = this.ipoUrlValue.trim();
      if (this.ipoUrlValue.length > 0) {
        this.ipoUrl.add.push(this.ipoUrlValue);
        this.ipoUrlValue = "";
      }
      this.typeUrlCheck = false;
    },
    handleIPOCancel() {
      let self = this;
      self.ipoFiles = {
        add: [],
        update: [],
        delete: [],
      };
      self.ipoUrl = {
        add: [],
        update: [],
        delete: [],
      };
      self.ipoUrlValue = "";
      self.ipoTypeUrlCheck = false;

      self.showIPODialog = false;

      self.ipoSoldShare = "Yes";
      self.ipoTotalProceeds = "";
      self.ipoNumberOfShares = "";
      self.ipoDateSold = moment().format("yyyy-MM-DD");
      self.ipoPricePerShare = "";
      self.ipoDistribution = "";
      self.ipoRecycled = "";
      // self.ipoPurchasePPS = "";
      self.ipoNumberOfSharesYouHold = "";
      self.ipoLockUpStartDate = moment().format("yyyy-MM-DD");
      self.ipoPeriod = "";
      self.ipoAgentName = "";
      self.ipoAgentCompany = "";
      self.ipoAgentPhone = "";
      self.ipoAgentEmail = "";
      self.ipoAgentNote = "";
      self.ipoAgentNoteId = "";
    },

    async showEditIPO() {
      let self = this;

      let noteData = null;

      let ipoFiles = self.$store.getters["file/filesByPortfloioId"](
        self.data._id
      ).filter((item) => {
        return item.section === "ipo";
      });

      self.ipoFiles.update = ipoFiles.filter((item) => {
        return item.link_type === "File";
      });

      self.ipoUrl.update = ipoFiles.filter((item) => {
        return item.link_type === "URL";
      });

      if (self.data.ipo_info.ipoAgentNoteId) {
        const notes = await api.get(`note/${self.data._id}`);
        if (
          notes &&
          notes.data &&
          notes.data.encrypt &&
          notes.data.encrypt.data &&
          notes.data.encrypt.data.length
        ) {
          noteData = notes.data.encrypt.data.find((item) => {
            return item._id === self.data.ipo_info.ipoAgentNoteId;
          });
        }
      }

      self.ipoSoldShare = self.data.ipo_info.ipoSoldShare;
      self.ipoTotalProceeds = self.data.ipo_info.ipoTotalProceeds;
      self.ipoNumberOfShares = self.data.ipo_info.ipoNumberOfShares;
      self.ipoDateSold = self.data.ipo_info.ipoDateSold;
      self.ipoPricePerShare = self.data.ipo_info.ipoPricePerShare;
      self.ipoDistribution = self.data.ipo_info.ipoDistribution;
      self.ipoRecycled = self.data.ipo_info.ipoRecycled;
      // self.ipoPurchasePPS = 0;
      self.ipoNumberOfSharesYouHold =
        self.data.ipo_info.ipoNumberOfSharesYouHold;
      self.ipoLockUpStartDate = self.data.ipo_info.ipoLockUpStartDate;
      self.ipoPeriod = self.data.ipo_info.ipoPeriod;
      self.ipoAgentName = self.data.ipo_info.ipoAgentName;
      self.ipoAgentCompany = self.data.ipo_info.ipoAgentCompany;
      self.ipoAgentPhone = self.data.ipo_info.ipoAgentPhone;
      self.ipoAgentEmail = self.data.ipo_info.ipoAgentEmail;
      self.ipoAgentNote = noteData ? noteData.description : "";
      self.ipoAgentNoteId = noteData ? noteData._id : "";

      this.showIPODialog = true;
    },

    async showEditAcquisition() {
      let self = this;

      let noteData = null;

      let ipoFiles = self.$store.getters["file/filesByPortfloioId"](
        self.data._id
      ).filter((item) => {
        return item.section === "acquisition";
      });

      self.ipoFiles.update = ipoFiles.filter((item) => {
        return item.link_type === "File";
      });

      self.ipoUrl.update = ipoFiles.filter((item) => {
        return item.link_type === "URL";
      });

      if (self.data.acquisition_info.acquisitionNoteId) {
        const notes = await api.get(`note/${self.data._id}`);
        if (
          notes &&
          notes.data &&
          notes.data.encrypt &&
          notes.data.encrypt.data &&
          notes.data.encrypt.data.length
        ) {
          noteData = notes.data.encrypt.data.find((item) => {
            return item._id === self.data.acquisition_info.acquisitionNoteId;
          });
        }
      }

      self.acquisitionAquiringCompanyName =
        self.data.acquisition_info.acquisitionAquiringCompanyName;

      self.acquisitionCompanyDeatils =
        self.data.acquisition_info.acquisitionCompanyDeatils;

      self.oldUcIdOfAcquiringCompany =
        self.data.acquisition_info.acquisitionCompanyDeatils.ucid;

      self.acquisitionType = self.data.acquisition_info.acquisitionType;
      self.acquisitionExitValue =
        self.data.acquisition_info.acquisitionExitValue;
      self.acquisitionCashProceeds =
        self.data.acquisition_info.acquisitionCashProceeds;
      self.acquisitionEscrow = self.data.acquisition_info.acquisitionEscrow;
      self.acquisitionRecycle = self.data.acquisition_info.acquisitionRecycle;
      self.acquisitionDistribution =
        self.data.acquisition_info.acquisitionDistribution;
      self.acquisitionSharesIssued =
        self.data.acquisition_info.acquisitionSharesIssued;
      self.acquisitionPricePerShare =
        self.data.acquisition_info.acquisitionPricePerShare;
      self.acquisitionOwnershipPercent =
        self.data.acquisition_info.acquisitionOwnershipPercent;
      self.acquisitionTransactionDate =
        self.data.acquisition_info.acquisitionTransactionDate;
      self.acquisitionNote = noteData ? noteData.description : "";
      self.acquisitionNoteId = self.data.acquisition_info.acquisitionNoteId;

      self.showAcquisitionDialog = true;

      setTimeout(() => {
        self.$refs.acquisitiontypeahead.inputValue =
          self.data.acquisition_info.acquisitionAquiringCompanyName;
      }, 0);
    },

    async ipoSave() {
      let self = this;

      // check validation

      if (self.ipoAgentPhone) {
        let reg = new RegExp(
          /^[+]?(\d{1,2})?[\s.-]?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
        );
        if (!reg.test(self.ipoAgentPhone)) {
          self.$toaster.error("Enter a valid agent phone.");
          return;
        }
      }
      if (self.ipoAgentEmail) {
        let reg = new RegExp(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        if (!reg.test(self.ipoAgentEmail)) {
          self.$toaster.error("Enter a valid agent email.");
          return;
        }
      }

      self.isIPOSaving = true;

      let notesData,
        noteId = null;
      if (self.ipoAgentNote || self.ipoAgentNoteId) {
        notesData = await self.saveNotes(
          self.ipoAgentNote,
          self.ipoAgentNoteId
        );

        if (self.ipoAgentNoteId) {
          noteId = self.ipoAgentNoteId;
        } else {
          if (
            notesData &&
            notesData.data &&
            notesData.data.encrypt &&
            notesData.data.encrypt.success &&
            notesData.data.encrypt.success[0] &&
            notesData.data.encrypt.success[0]._id
          ) {
            noteId = notesData.data.encrypt.success[0]._id;
          }
        }
      }

      self.deleteFiles();

      api
        .patch(
          `${self.$route.params.account_id}/${self.$route.params.workspace_id}/portfolio/${self.data.ucid}/ipo-info`,
          {
            encrypt: {
              data: {
                portfolio: self.data,
                portfolio_item_id: self.data._id,
                ipoInfo: {
                  status: "IPO",
                  ipo_info: {
                    ipoSoldShare: self.ipoSoldShare,
                    ipoTotalProceeds: self.ipoTotalProceeds,
                    ipoNumberOfShares: self.ipoNumberOfShares,
                    ipoDateSold: self.ipoDateSold,
                    ipoPricePerShare: self.ipoPricePerShare,
                    ipoDistribution: self.ipoDistribution,
                    ipoRecycled: self.ipoRecycled,
                    // ipoPurchasePPS: self.ipoPurchasePPS,
                    ipoNumberOfSharesYouHold: self.ipoNumberOfSharesYouHold,
                    ipoLockUpStartDate: self.ipoLockUpStartDate,
                    ipoPeriod: self.ipoPeriod,
                    ipoAgentName: self.ipoAgentName,
                    ipoAgentCompany: self.ipoAgentCompany,
                    ipoAgentPhone: self.ipoAgentPhone,
                    ipoAgentEmail: self.ipoAgentEmail,
                    ipoAgentNote: self.ipoAgentNote,
                    ipoAgentNoteId: noteId,
                  },
                },
              },
            },
          }
        )
        .then(async (data) => {
          await self.saveRegistrar({
            amount: self.ipoTotalProceeds,
            portfolioItemId: self.data._id,
            date: self.ipoDateSold,
            type: "IPO",
          });

          self.$store.dispatch("portfolio/_apiFetchPortfolio").then((res) => {
            self.$emit("investment-save", null);
            if (self.ipoFiles.add.length || self.ipoUrl.add.length) {
              self.saveFiles(res, "ipo");
            } else {
              self.$toaster.success("Saved Successfully.");
              self.isIPOSaving = false;
              self.handleIPOCancel();
            }
          });
        })
        .catch((err) => {
          console.log(err);
          self.$toaster.error("Failed to save");
          self.isIPOSaving = false;
        });
    },

    saveFiles(savedDoc, dataSection) {
      let self = this;
      let filePayload = {
        files: [],
        data: [],
      };

      _.forEach(self.ipoFiles.add, (item) => {
        if (item) {
          filePayload.files.push(item);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "portfolio",
            document_id: self.data._id,
            portfolio_item: self.data,
            link_type: "File",
            section: dataSection,
          });
        }
      });

      _.forEach(self.ipoUrl.add, (item) => {
        if (item) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "portfolio",
            document_id: self.data._id,
            portfolio_item: self.data,
            link_type: "URL",
            section: dataSection,
            url: item,
          });
        }
      });

      self.$store.dispatch("file/createFile", filePayload).then(
        (item) => {
          self.$store.dispatch("file/start", null, { root: true });
          if (
            item.data.encrypt.limitExceededMessage &&
            item.data.encrypt.limitExceededMessage.length > 0 &&
            item.data.encrypt.limitExceededMessage == "Storage Limit Exceeded"
          ) {
            self.$toaster.error(
              "Storage limit exceeded. Upgrade your plan to add more"
            );
          } else {
            self.isIPOSaving = false;
            self.isAcquisitionSaving = false;
            self.$toaster.success("Saved Successfully.");
            self.handleIPOCancel();
            self.handleAcquisitionCancel();
          }
        },
        (error) => {
          self.$toaster.error("Failed to save the data.");
          self.isIPOSaving = false;
          self.isAcquisitionSaving = false;
        }
      );
    },

    calculateIPOProceedsDistributionRecycled(type) {
      let self = this;

      switch (type) {
        case "total":
          self.ipoDistribution =
            (self.ipoTotalProceeds ? parseFloat(self.ipoTotalProceeds) : 0) -
            (self.ipoRecycled ? parseFloat(self.ipoRecycled) : 0);
          self.ipoRecycled =
            (self.ipoTotalProceeds ? parseFloat(self.ipoTotalProceeds) : 0) -
            (self.ipoDistribution ? parseFloat(self.ipoDistribution) : 0);
          break;
        case "distribution":
          self.ipoTotalProceeds =
            (self.ipoDistribution ? parseFloat(self.ipoDistribution) : 0) +
            (self.ipoRecycled ? parseFloat(self.ipoRecycled) : 0);
          self.ipoRecycled =
            (self.ipoTotalProceeds ? parseFloat(self.ipoTotalProceeds) : 0) -
            (self.ipoDistribution ? parseFloat(self.ipoDistribution) : 0);
          break;
        case "recycled":
          self.ipoTotalProceeds =
            (self.ipoDistribution ? parseFloat(self.ipoDistribution) : 0) +
            (self.ipoRecycled ? parseFloat(self.ipoRecycled) : 0);
          self.ipoDistribution =
            (self.ipoTotalProceeds ? parseFloat(self.ipoTotalProceeds) : 0) -
            (self.ipoRecycled ? parseFloat(self.ipoRecycled) : 0);
          break;
      }
    },

    handleAcquisitionTab(tab) {
      this.acquisitionType = tab;

      return false;
    },

    saveNewCompany() {
      return new Promise((res) => {
        let self = this;

        let serverData = new Company({});
        serverData.cost = 0;
        serverData.value = 0;
        serverData.direct = "Direct";
        if (
          self.acquisitionCompanyDeatils &&
          self.acquisitionCompanyDeatils.properties &&
          self.acquisitionCompanyDeatils.properties.permalink
        ) {
          serverData.name = self.acquisitionCompanyDeatils.properties.name;

          serverData.website = self.acquisitionCompanyDeatils.properties
            .homepage_url
            ? self.acquisitionCompanyDeatils.properties.homepage_url
            : "";
          serverData.facebook = self.acquisitionCompanyDeatils.properties
            .facebook_url
            ? self.acquisitionCompanyDeatils.properties.facebook_url
            : "";
          serverData.linkedin = self.acquisitionCompanyDeatils.properties
            .linkedin_url
            ? self.acquisitionCompanyDeatils.properties.linkedin_url
            : "";
          serverData.twitter = self.acquisitionCompanyDeatils.properties
            .twitter_url
            ? self.acquisitionCompanyDeatils.properties.twitter_url
            : "";
          serverData.logo_url = self.acquisitionCompanyDeatils.properties
            .profile_image_url
            ? self.acquisitionCompanyDeatils.properties.profile_image_url
            : "";
          serverData.permalink = self.acquisitionCompanyDeatils.properties
            .permalink
            ? self.acquisitionCompanyDeatils.properties.permalink
            : "";
          serverData.cb_data = self.acquisitionCompanyDeatils;
        } else {
          serverData.name = self.acquisitionAquiringCompanyName;
          serverData.data_status = "Confirmed";
          serverData.company_status = "Unknown";
        }
        serverData
          .validate()
          .then((validateResponse) => {
            return serverData.writeToServer();
          })
          .then((dataFromServer) => {
            //self.refreshPortfolioTable(serverData);
            if (
              serverData.data_status == "Unconfirmed" &&
              serverData.permalink &&
              serverData.permalink != ""
            ) {
              let url = `${this.$route.params.account_id}/${this.$route.params.workspace_id}/company/confirm`;
              api
                .post(url, {
                  encrypt: {
                    data: {
                      company: serverData,
                      confirmedCompany: serverData.cb_data
                        ? serverData.cb_data
                        : {},
                    },
                  },
                })
                .then((confirmData) => {
                  this.$store
                    .dispatch("portfolio/_apiFetchPortfolio")
                    .then((data) => {
                      self.$store.dispatch("contacts/getContacts");
                      self.$store.dispatch("suggestions/getSuggestions");
                    })
                    .catch((error) => {
                      console.log("refresh error", error);
                    });
                })
                .catch((err) => {
                  this.$toaster.error("Unable to confirm company.");
                });
              res(dataFromServer);
            } else {
              self.$store.dispatch("contacts/getContacts");
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((d) => {
                  let data = self.$store.getters["portfolio/portfolioData"];
                })
                .catch((error) => {
                  console.log("refresh error", error);
                });
              res(dataFromServer);
            }
          })
          .catch((error) => {
            console.log("validateResponse error", error);
            self.$toaster.error(error.error);
          });
      });
    },
    async acquisitionSave() {
      let self = this;

      if (!self.acquisitionAquiringCompanyName) {
        self.$toaster.error("Acquiring Company cannot be empty.");
        return;
      }

      self.isAcquisitionSaving = true;

      let allCompanies = self.$store.getters["portfolio/portfolioData"];

      let dataFromServer;
      if (
        self.acquisitionCompanyDeatils &&
        self.acquisitionCompanyDeatils.ucid &&
        self.$refs.acquisitiontypeahead.inputValue ==
          self.acquisitionCompanyDeatils.name
      ) {
        dataFromServer = self.acquisitionCompanyDeatils;
        self.oldUcIdOfAcquiringCompany = null;
      } else {
        dataFromServer = allCompanies.find((item) => {
          return (
            self.acquisitionCompanyDeatils &&
            self.acquisitionCompanyDeatils.properties &&
            item.permalink ===
              self.acquisitionCompanyDeatils.properties.permalink
          );
        });

        if (!dataFromServer) {
          dataFromServer = await self.saveNewCompany();
        }
      }

      let notesData,
        noteId = null;
      if (self.acquisitionNote || self.acquisitionNoteId) {
        notesData = await self.saveNotes(
          self.acquisitionNote,
          self.acquisitionNoteId
        );

        if (self.acquisitionNoteId) {
          noteId = self.acquisitionNoteId;
        } else {
          if (
            notesData &&
            notesData.data &&
            notesData.data.encrypt &&
            notesData.data.encrypt.success &&
            notesData.data.encrypt.success[0] &&
            notesData.data.encrypt.success[0]._id
          ) {
            noteId = notesData.data.encrypt.success[0]._id;
          }
        }
      }

      self.deleteFiles();

      api
        .patch(
          `${self.$route.params.account_id}/${self.$route.params.workspace_id}/portfolio/${self.data.ucid}/acquisition-info`,
          {
            encrypt: {
              data: {
                status: "Acquired",
                oldUcIdOfAcquiringCompany: self.oldUcIdOfAcquiringCompany,
                portfolio_item_id: self.data._id,
                acquisition_info: {
                  acquisitionAquiringCompanyName:
                    self.acquisitionAquiringCompanyName,
                  acquisitionCompanyDeatils: dataFromServer,
                  acquisitionType: self.acquisitionType,
                  acquisitionExitValue: self.acquisitionExitValue,
                  acquisitionCashProceeds: self.acquisitionCashProceeds,
                  acquisitionEscrow: self.acquisitionEscrow,
                  acquisitionRecycle: self.acquisitionRecycle,
                  acquisitionDistribution: self.acquisitionDistribution,
                  acquisitionSharesIssued: self.acquisitionSharesIssued,
                  acquisitionPricePerShare: self.acquisitionPricePerShare,
                  acquisitionOwnershipPercent: self.acquisitionOwnershipPercent,
                  acquisitionTransactionDate: self.acquisitionTransactionDate,
                  acquisitionNote: self.acquisitionNote,
                  acquisitionNoteId: noteId,
                  acquisitionCompanyUcId: dataFromServer.ucid,
                  acquisitionAcquiredCompanyUcId: self.data.ucid,
                  acquisitionAcquiredCompanyName: self.data.name,
                },
              },
            },
          }
        )
        .then(async (data) => {
          await self.saveRegistrar({
            amount: self.acquisitionCashProceeds,
            portfolioItemId: self.data._id,
            date: self.acquisitionTransactionDate,
            type: "Acquired",
          });

          self.$store.dispatch("portfolio/_apiFetchPortfolio").then((res) => {
            self.$emit("investment-save", null);
            if (self.ipoFiles.add.length || self.ipoUrl.add.length) {
              self.saveFiles(res, "acquisition");
            } else {
              self.$toaster.success("Saved Successfully.");
              self.handleAcquisitionCancel();
            }
          });
        })
        .catch((err) => {
          console.log(err);
          self.$toaster.error("Failed to save");
          self.isAcquisitionSaving = false;
        });
    },

    handleAcquisitionCancel() {
      let self = this;
      self.ipoFiles = {
        add: [],
        update: [],
        delete: [],
      };
      self.ipoUrl = {
        add: [],
        update: [],
        delete: [],
      };
      self.ipoUrlValue = "";
      self.ipoTypeUrlCheck = false;

      self.$refs.acquisitiontypeahead.inputValue = "";
      self.acquisitionAquiringCompanyName = "";
      self.acquisitionCompanyDeatils = null;
      self.isAcquisitionSaving = false;
      self.showAcquisitionDialog = false;
      self.acquisitionCompaniesList = [];
      self.acquisitionType = "cash";
      self.acquisitionExitValue = "";
      self.acquisitionCashProceeds = "";
      self.acquisitionEscrow = "";
      self.acquisitionRecycle = "";
      self.acquisitionDistribution = "";
      self.acquisitionSharesIssued = "";
      self.acquisitionPricePerShare = "";
      self.acquisitionOwnershipPercent = "";
      self.acquisitionTransactionDate = moment().format("yyyy-MM-DD");
      self.acquisitionNote = "";
      self.acquisitionNoteId = "";
    },

    onAfterCompanySelection(selectedValue) {
      let self = this;

      self.acquisitionCompanyDeatils = selectedValue;
    },

    async saveNotes(note, noteId) {
      const self = this;

      return new Promise(async (res) => {
        let userName = self.$store.getters["user/user"];
        let userNameString = `${userName.firstName} ${userName.lastName} `;

        let obj = {};
        obj.name = userNameString;
        obj.entity = "portfolio";
        obj.portfolio_item = self.data._id;
        obj.description = note;

        let notesData;

        if (!noteId) {
          notesData = await api.post(
            `note/${self.$route.params.workspace_id}`,
            {
              encrypt: {
                data: obj,
              },
            }
          );
        } else {
          notesData = await api.patch(`note`, {
            encrypt: {
              data: Object.assign({ _id: noteId }, obj),
            },
          });
        }

        self.$emit("notes-save", {});

        res(notesData);
      });
    },

    async getCompanies(query) {
      this.acquisitionCompaniesLoading = true;

      const response = await api.get(`search?key=${query}`);

      const res = cbAdapter(response);

      const suggestions = res;

      this.acquisitionCompaniesLoading = false;

      if (suggestions.data.items && suggestions.data.items.length > 0)
        this.acquisitionCompaniesList = suggestions.data.items;
      else {
        this.acquisitionCompaniesList = [
          {
            properties: {
              name: this.diligenceName,
              short_description: "No results Found. Continue..",
            },
          },
        ];
      }

      let allCompanies = this.$store.getters["portfolio/portfolioData"];

      let finalList = [].concat(allCompanies);
      for (let i = 0; i < this.acquisitionCompaniesList.length; i++) {
        let found = false;
        for (let j = 0; j < allCompanies.length; j++) {
          if (
            allCompanies[j] &&
            this.acquisitionCompaniesList[i] &&
            this.acquisitionCompaniesList[i].properties &&
            this.acquisitionCompaniesList[i].properties.permalink ==
              allCompanies[j].permalink
          ) {
            found = true;
          }
        }

        if (!found && this.acquisitionCompaniesList[i]) {
          finalList.push(this.acquisitionCompaniesList[i]);
        }
      }

      this.acquisitionCompaniesList = [].concat(finalList);
    },
    checkCompany(item) {
      return item.name || item.properties.name || "";
    },
    calculateAcquisitionValues(type) {
      let self = this;

      switch (type) {
        case "exitValue":
          self.acquisitionCashProceeds =
            (self.acquisitionExitValue
              ? parseFloat(self.acquisitionExitValue)
              : 0) -
            (self.acquisitionEscrow ? parseFloat(self.acquisitionEscrow) : 0);
          self.acquisitionEscrow =
            (self.acquisitionExitValue
              ? parseFloat(self.acquisitionExitValue)
              : 0) -
            (self.acquisitionCashProceeds
              ? parseFloat(self.acquisitionCashProceeds)
              : 0);
          break;
        case "cashProceeds":
          // self.acquisitionEscrow =
          //   (self.acquisitionExitValue
          //     ? parseFloat(self.acquisitionExitValue)
          //     : 0) -
          //   (self.acquisitionCashProceeds
          //     ? parseFloat(self.acquisitionCashProceeds)
          //     : 0);
          self.acquisitionExitValue =
            (self.acquisitionCashProceeds
              ? parseFloat(self.acquisitionCashProceeds)
              : 0) +
            (self.acquisitionEscrow ? parseFloat(self.acquisitionEscrow) : 0);
          // self.acquisitionRecycle =
          //   (self.acquisitionCashProceeds
          //     ? parseFloat(self.acquisitionCashProceeds)
          //     : 0) -
          //   (self.acquisitionDistribution
          //     ? parseFloat(self.acquisitionDistribution)
          //     : 0);
          // self.acquisitionDistribution =
          //   (self.acquisitionCashProceeds
          //     ? parseFloat(self.acquisitionCashProceeds)
          //     : 0) -
          //   (self.acquisitionRecycle ? parseFloat(self.acquisitionRecycle) : 0);
          break;
        case "escrow":
          // self.acquisitionCashProceeds =
          //   (self.acquisitionExitValue
          //     ? parseFloat(self.acquisitionExitValue)
          //     : 0) -
          //   (self.acquisitionEscrow ? parseFloat(self.acquisitionEscrow) : 0);
          self.acquisitionExitValue =
            (self.acquisitionCashProceeds
              ? parseFloat(self.acquisitionCashProceeds)
              : 0) +
            (self.acquisitionEscrow ? parseFloat(self.acquisitionEscrow) : 0);
          break;
        case "recycle":
          self.acquisitionCashProceeds =
            (self.acquisitionRecycle
              ? parseFloat(self.acquisitionRecycle)
              : 0) +
            (self.acquisitionDistribution
              ? parseFloat(self.acquisitionDistribution)
              : 0);
          // self.acquisitionDistribution =
          //   (self.acquisitionCashProceeds
          //     ? parseFloat(self.acquisitionCashProceeds)
          //     : 0) -
          //   (self.acquisitionRecycle ? parseFloat(self.acquisitionRecycle) : 0);

          self.calculateAcquisitionValues("cashProceeds");

          break;
        case "distribution":
          self.acquisitionCashProceeds =
            (self.acquisitionRecycle
              ? parseFloat(self.acquisitionRecycle)
              : 0) +
            (self.acquisitionDistribution
              ? parseFloat(self.acquisitionDistribution)
              : 0);

          self.calculateAcquisitionValues("cashProceeds");

          // self.acquisitionRecycle =
          //   (self.acquisitionCashProceeds
          //     ? parseFloat(self.acquisitionCashProceeds)
          //     : 0) -
          //   (self.acquisitionDistribution
          //     ? parseFloat(self.acquisitionDistribution)
          //     : 0);
          break;
      }
    },

    statusChangePermission() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;

      let index = rolePermissions.findIndex((item) => {
        if (item == "EDIT COMPANY STATUS") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },

    saveRegistrar(data) {
      let self = this;
      return new Promise(async (res) => {
        let registararPayload = {
          amount: data.amount,
          portfolio_item: data.portfolioItemId,
          transaction_date: data.date,
          transaction_type: data.type,
          investment_type: "Proceeds",
        };

        let k = await self.$store.dispatch(
          "investment/apiRegistrarSave",
          registararPayload
        );
        res();
      });
    },
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    portfolio: Object,
    people: Object,
    referrals: Object,
    offerings: {
      type: Array,
      default() {
        return {};
      },
    },
    downloadProps: Object,
  },
  watch: {
    tags(newVal, oldVal) {
      // Set the dirty flag on first change to the tags array
      this.dirty = true;
    },
    acquisitionAquiringCompanyName: _.debounce(function (addr) {
      if (addr.length > 0) {
        this.getCompanies(addr);
      }
    }, 500),
  },
  data() {
    return {
      vals,
      investors: JSON.parse(JSON.stringify(this.people.investors)),
      founders: JSON.parse(JSON.stringify(this.people.founders)),
      advisors: JSON.parse(JSON.stringify(this.people.advisors)),
      employees: JSON.parse(JSON.stringify(this.people.employees)),
      founders: [],
      lessContentHtml: "",
      sharingNote: "",
      refreshForm: true,
      moreContentHtml: "",
      founderArray: [],
      investorArray: [],
      advisorArray: [],
      employeeArray: [],
      peopleData: [],
      companyDesc: "",
      employeePopover: {},
      employeeTargert: "",
      showEditModalPopup: false,
      editCompanyModalProps: {},
      dirty: false,
      tags: [],
      validTags: [],
      invalidTags: [],
      duplicateTags: [],
      modalShow: false,
      submit: false,
      showDeleteModal: false,
      modalContext: { name: "deleteprompt" },
      showEditIcon: false,
      isUpdatedByCompany: false,
      tractionData: [],
      isShow: false,
      contractArray: [
        {
          label: "Recurring",
          value: "Recurring",
        },
        {
          label: "Transactional",
          value: "Transactional",
        },
      ],
      showSpinner: false,
      editTractionData: {},
      editTractionDataRunway: 0,
      editTractionDataCashOutDate: "",
      editTractionDataContractType: "",
      investedCompanies: [],
      num_portfolio_organization: 0,
      exits: 0,
      showHistoryIcon: false,
      showHistoryTableModal: false,
      historyTabulator: null,
      editTractionDataDate: "",
      isEditKpi: false,

      showIPODialog: false,
      ipoSoldShare: "Yes",
      ipoTotalProceeds: "",
      ipoNumberOfShares: "",
      ipoDateSold: moment().format("yyyy-MM-DD"),
      ipoPricePerShare: "",
      ipoDistribution: "",
      ipoRecycled: "",
      // ipoPurchasePPS : "",
      ipoNumberOfSharesYouHold: "",
      ipoLockUpStartDate: moment().format("yyyy-MM-DD"),
      ipoPeriod: "",
      ipoAgentName: "",
      ipoAgentCompany: "",
      ipoAgentPhone: "",
      ipoAgentEmail: "",
      ipoAgentNote: "",
      ipoAgentNoteId: "",
      ipoFiles: {
        add: [],
        update: [],
        delete: [],
      },
      ipoUrl: {
        add: [],
        update: [],
        delete: [],
      },
      ipoTypeUrlCheck: false,
      ipoUrlValue: "",
      isIPOSaving: false,

      isAcquisitionSaving: false,
      showAcquisitionDialog: false,
      acquisitionCompaniesList: [],
      acquisitionCompaniesLoading: false,
      acquisitionAquiringCompanyName: "",
      acquisitionCompanyDeatils: null,
      acquisitionType: "cash",
      acquisitionExitValue: "",
      acquisitionCashProceeds: "",
      acquisitionEscrow: "",
      acquisitionRecycle: "",
      acquisitionDistribution: "",
      acquisitionSharesIssued: "",
      acquisitionPricePerShare: "",
      acquisitionOwnershipPercent: "",
      acquisitionTransactionDate: moment().format("yyyy-MM-DD"),
      acquisitionNote: "",
      acquisitionNoteId: "",
      oldUcIdOfAcquiringCompany: "",

      downloadLink: "",

      showConfirmModal: false,
      statusConfirmMessage: "",
    };
  },
};
</script>
<style lang="scss">
.company-card-block {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.logo-image {
  width: 100%;
  max-width: 300px;
  max-height: 300px;
  /*sorcery so it doesn't stretch the logo*/
  align-self: center;
  /*fairy dust so it maintains aspect ratio*/
  -o-object-fit: contain;
  object-fit: contain;
}

.logo-box {
  padding: 10px;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  /* background-color: #64676f; */
  border: none;
  flex: 0 0 200px;
}

.statBlockContainer {
  flex: 1 1 auto;
}

@media only screen and (max-width: 1270px) {
  .statBlockContainer {
    width: auto;
  }
}

@media only screen and (max-width: 768px) {
  .company-card-block {
    flex-direction: column;
  }
  .logo-box {
    height: auto;
    width: 100%;
  }
}

.full-width {
  width: 100%;
}

.company-field-table {
  th {
    // min-width: 160px;
    min-width: 175px;
  }
  th,
  td {
    max-width: 50%;
    padding: 2px 5px;
    font-size: 14px;
    word-break: break-word;

    p {
      margin-bottom: 0;
    }
  }
  th {
    color: #393d40;
  }
  td {
    color: #848484;
    text-align: right;
  }
  tr:nth-child(odd) {
    // background-color: #e6e6e6;
    background-color: rgba(84, 69, 243, 0.1);
  }
}
.hide {
  display: none !important;
}

.companyProfileTableBorderless .table {
  table-layout: fixed;
  width: 100%;
}

.negativemargin {
  margin-left: -100px;
}

.peoplePopOverImage {
  padding-top: 15px;
  padding-bottom: 18px;
  padding-right: 15px;
}

.peoplePopOverMouseOver {
  padding-bottom: 10px;
  cursor: pointer;
}

.peoplePopOverSocialMedia {
  color: #5445f3;
  font-size: 18px;
  padding-right: 5px;
  padding-top: 14px;
  padding-bottom: 12px;
}

.tractionHistoryTable .tabulator-header {
  height: auto !important;
  word-break: break-word !important;
}
.el-select.status-dd {
  width: 110px;
  input {
    border: none;
    background-color: transparent;
    border-radius: 10px;
    font-size: 12px;
    height: 14px;
    line-height: 1.5;
  }
  .el-select__caret {
    font-size: 10px;
    line-height: 1.5;
  }
  .el-input--suffix:hover {
    background-color: transparent;
  }
}

.el-select .el-input:hover input,
.select-primary.el-select
  .el-input:hover
  .el-input__icon:not(.el-select__caret) {
  background-color: transparent !important;
}

.radio-wrapper {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  .form-check {
    label {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 5px 20px 0px 0;
      .form-check-sign {
        margin-right: 5px;
      }
    }
  }
}
.url-input-form {
  margin: 0px;
  height: 35px;
  border-bottom-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
.ipo-files {
  .attachment-name-class {
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    display: inline-block;
    flex-wrap: wrap;
  }
}

.fileItem a {
  display: inline-block;
}

.lockup-text {
  color: #000;
  font-size: 13px;
  margin-bottom: 20px;
}
</style>
